import { tokens } from './tokens';

const translations: Record<string, string> = {
  [tokens.platform.teams.manager.title]: 'Equipes',
  [tokens.platform.teams.add_organization.title]: 'Adicionar organização',
  [tokens.platform.teams.organization.start.title]: 'Iniciar uma Organização',
  [tokens.platform.teams.organization.start.description]: 'Crie sua organização e convide novos usuários para participar enviando um convite por e-mail.',
  [tokens.platform.teams.organization.nameInput]: 'Nome da Organização',
  [tokens.platform.teams.plan]: 'Plano {{currentPlan}}',
  [tokens.onboarding.organization.title]: 'Criar uma organização',
  [tokens.onboarding.organization.description]: 'Escolha um nome para sua organização e convide membros para participarem dela.',
  [tokens.onboarding.organization_pricing.features.questions]: '{{count}} perguntas',
  [tokens.onboarding.organization_pricing.features.pages]: '{{count}} páginas',
  [tokens.onboarding.organization_pricing.features.minutes]: '{{count}} minutos',
  [tokens.onboarding.organization_pricing.features.users]: 'Até {{count}} usuário',
  [tokens.onboarding.organization_pricing.features.users_other]: 'Até {{count}} usuários',
  [tokens.onboarding.organization_pricing.features.multi_provider]: 'Multi provedor',
  [tokens.onboarding.organization_pricing.features.dedicated_support]: 'Suporte dedicado',
  [tokens.onboarding.organization_pricing.features.priority_queues]: 'Prioridade nas filas',
  [tokens.onboarding.organization_pricing.features.low_priority]: 'Baixa prioridade nas filas',
  [tokens.onboarding.organization_pricing.features.slack_support]: 'Suporte via Slack',
  [tokens.onboarding.organization_pricing.features.high_question_limit]: 'Limite alto de perguntas',
  [tokens.onboarding.organization_pricing.features.unlimited_pages]: 'Páginas ilimitadas',
  [tokens.onboarding.organization_pricing.features.unlimited_minutes]: 'Minutos ilimitados',
  [tokens.onboarding.organization_pricing.features.unlimited_users]: 'Usuários ilimitados',
  [tokens.onboarding.organization_pricing.features.advanced_multi_provider]: 'Multi provedor avançado',
  [tokens.onboarding.organization_pricing.features.separate_tenant]: 'Ambiente dedicado',
  [tokens.onboarding.organization_pricing.features.sso]: 'SSO (login corporativo)',
  [tokens.onboarding.organization_pricing.features.guaranteed_sla]: 'SLA garantido',
  [tokens.onboarding.organization_pricing.features.security_report]: 'Relatório de segurança',
  [tokens.onboarding.organization_pricing.features.xlsx_import]: 'Importação XLSX',
  [tokens.onboarding.organization_pricing.tooltips.questions]: 'Número de perguntas mensais que você pode fazer',
  [tokens.onboarding.organization_pricing.tooltips.pages]: 'Número de páginas que podem ser indexadas',
  [tokens.onboarding.organization_pricing.tooltips.minutes]: 'Tempo de processamento mensal',
  [tokens.onboarding.organization_pricing.tooltips.multi_provider]: 'Capacidade de conectar a múltiplos provedores de IA',
  [tokens.onboarding.organization_pricing.tooltips.low_priority]: 'Prioridade reduzida na fila de atendimento',
  [tokens.onboarding.organization_pricing.tooltips.slack_support]: 'Suporte disponível via Slack',
  [tokens.onboarding.organization_pricing.tooltips.sso]: 'Autenticação corporativa via login único (SSO)',
  [tokens.onboarding.organization_pricing.tooltips.high_question_limit]: 'Limite personalizado com base nas suas necessidades',
  [tokens.onboarding.organization_pricing.plans.description.individual_users]: 'Para usuários individuais',
  [tokens.onboarding.organization_pricing.plans.description.growing_teams]: 'Para equipes em crescimento',
  [tokens.onboarding.organization_pricing.plans.description.large_organizations]: 'Para grandes organizações',
  [tokens.onboarding.organization_pricing.upgrade_plan]: 'Atualize seu plano',
  [tokens.onboarding.organization_pricing.choose_plan_for_organization]: 'Escolha um plano para sua organização',
  [tokens.onboarding.organization_pricing.current_plan_message]: 'Você está atualmente no plano {{currentPlan}}. Explore nossos outros planos para encontrar o que melhor atende às suas necessidades em crescimento.',
  [tokens.onboarding.organization_pricing.congratulations_choose_plan]: 'Parabéns por criar sua organização! Agora escolha o plano ideal para suas necessidades.',
  [tokens.onboarding.organization_pricing.continue_with_plan]: 'Continue com o plano {{currentPlan}}',
  [tokens.onboarding.organization_pricing.subscribe_now]: 'Assine agora',
  [tokens.onboarding.organization_pricing.contact_sales]: 'Contate as vendas',
  [tokens.onboarding.organization_pricing.month]: 'Mês',
  [tokens.onboarding.organization_pricing.custom]: 'Personalizado',
  [tokens.onboarding.organization_pricing.contact_sales]: 'Contate as vendas',
  [tokens.onboarding.organization_pricing.most_popular]: 'Mais popular',
  [tokens.onboarding.organization_pricing.contact_sales_modal.upgrade_to_enterprise]: 'Atualize para o plano Enterprise',
  [tokens.onboarding.organization_pricing.contact_sales_modal.submit_request]: 'Envie sua solicitação para avaliar a migração para o plano Enterprise',
  [tokens.onboarding.organization_pricing.contact_sales_modal.my_email]: 'Meu email',
  [tokens.onboarding.organization_pricing.contact_sales_modal.subject]: 'Assunto',
  [tokens.onboarding.organization_pricing.contact_sales_modal.describe_needs]: 'Descreva suas necessidades específicas',
  [tokens.onboarding.organization_pricing.contact_sales_modal.send_request]: 'Enviar solicitação',
  [tokens.onboarding.organization_pricing.contact_sales_modal.additional_message]: 'Mensagem adicional (opcional)',
  [tokens.onboarding.organization_pricing.contact_sales_modal.request_to_upgrade_placeholder]: 'Atualizar para plano Empresarial',
  [tokens.onboarding.organization_pricing.contact_sales_modal.request_submitted]: 'Solicitação enviada!',
  [tokens.onboarding.organization_pricing.contact_sales_modal.sales_team_contact]: 'Nossa equipe de vendas entrará em contato em breve para discutir suas necessidades empresariais.',
  [tokens.onboarding.organization_pricing.contact_sales_modal.whats_next]: 'O que vem a seguir?',
  [tokens.onboarding.organization_pricing.contact_sales_modal.continue_with_community_plan]: 'Você pode continuar com o plano Community enquanto analisamos sua solicitação. Faremos a atualização manual da sua conta assim que o plano Enterprise for aprovado.',
  [tokens.onboarding.organization_pricing.contact_sales_modal.continue_with_current_plan]: 'Continue com o plano atual',
  [tokens.onboarding.organization_pricing.features.max_mb_docs]: '{{count}} MB para documentos',
  [tokens.onboarding.organization_pricing.features.max_mb_spreadsheets]: '{{count}} MB para planilhas',
  [tokens.onboarding.organization_pricing.features.max_mb_translator]: '{{count}} MB/mês para tradução',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_docs]: 'Limite de processamento para documentos',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_spreadsheets]: 'Limite de processamento para planilhas',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_translator]: 'Volume mensal processado no tradutor (renova a cada mês)',
  [tokens.dashboard.title]: 'Painel de estatísticas',
  [tokens.dashboard.tab.overview]: 'Visão geral',
  [tokens.dashboard.tab.analytics]: 'Análises',
  [tokens.dashboard.metric.questionsAnswered]: 'Perguntas feitas',
  [tokens.dashboard.metric.metricPeriod.description]: 'No período selecionado',
  [tokens.dashboard.metric.files]: 'Arquivos processados',
  [tokens.dashboard.metric.invitedUsers.title]: 'Usuários convidados',
  [tokens.dashboard.metric.invitedUsers.description]: 'Total de usuários convidados',
  [tokens.dashboard.metric.groups.title]: 'Grupos',
  [tokens.dashboard.metric.groups.description]: 'Grupos ativos',
  [tokens.dashboard.graph.title]: 'Visão geral',
  [tokens.dashboard.graph.subtitle]: 'Com base no período selecionado',
  [tokens.dashboard.graph.totalTooltip]: 'Total',
  [tokens.dashboard.graph.noInteractionData]: 'Nenhum dado de interação disponível para o período selecionado',
  [tokens.dashboard.chatHistoryTable.questionColumn]: 'Pergunta',
  [tokens.dashboard.chatHistoryTable.numberOfMessagesColumn]: 'Número de mensagens',
  [tokens.dashboard.chatHistoryTable.dateColumn]: 'Data',
  [tokens.dashboard.chatHistoryTable.askedBy]: 'Perguntada por',
  [tokens.dashboard.chatHistoryTable.title]: 'Controle de Interação',
  [tokens.dashboard.chatHistoryTable.description]: 'Acompanhe os detalhes das interações feitas via assistente e workstation',
  [tokens.dashboard.chatHistoryTable.questionFilter.placeholder]: 'Buscar pela primeira pergunta...',
  [tokens.dashboard.chatHistoryTable.modal.title]: 'Histórico de conversa',
  [tokens.dashboard.chatHistoryTable.noChatsFound]: 'Nenhum chat encontrado',
  [tokens.dashboard.chatHistoryTable.loadingChatHistory]: 'Carregando histórico de conversa',
  [tokens.dashboard.chatHistoryTable.deleteDialogTitle]: 'Tem certeza de que deseja deletar esta conversa?',
  [tokens.dashboard.chatHistoryTable.deleteDialogDescription]: 'Esta ação não pode ser desfeita.',
  [tokens.workstation.title]: 'Workstation',
  [tokens.workstation.subtitle]: 'Fale com o Alan e tenha uma experiência incrível.',
  [tokens.workstation.welcome]: 'Bem-vindo ao Workstation',
  [tokens.workstation.welcomeSubtitle]: 'Inicie uma conversa e explore tópicos com Alan, nosso assistente de IA.',
  [tokens.workstation.prompt.placeholder]: 'Pergunte algo ao Alan',
  [tokens.workstation.newchat]: 'Novo chat',
  [tokens.workstation.sources.title]: 'Fontes',
  [tokens.workstation.sources.empty]: 'Comece uma conversa para ver os resultados aqui.',
  [tokens.workstation.sources.search_results]: 'Resultados da pesquisa',
  [tokens.workstation.sources.relevance]: 'Relevância',
  [tokens.workstation.sources.previous]: 'Anterior',
  [tokens.workstation.sources.segmentTimestamps]: 'Segmentos de vídeo',
  [tokens.workstation.sources.videoStart]: 'Início',
  [tokens.workstation.sources.videoEnd]: 'Fim',
  [tokens.workstation.sources.next]: 'Próximo',
  [tokens.workstation.sources.passage_in_documents]: '{{count}} trecho em documentos',
  [tokens.workstation.sources.passage_in_documents_plural]: '{{count}} trechos em documentos',
  [tokens.workstation.sources.goToSource]: 'Ir para a fonte',
  [tokens.workstation.reasoning.title]: 'Raciocínio',
  [tokens.workstation.folders.label]: 'Pastas',
  [tokens.workstation.folders.empty]: 'Nenhuma pasta disponível',
  [tokens.workstation.folders.all_knowledge]: 'Toda a base de conhecimento',
  [tokens.workstation.folders.searchFolders]: 'Buscar pastas',
  [tokens.workstation.folders.selectAllFolders]: 'Marcar todos',
  [tokens.workstation.folders.deselectAllFolders]: 'Desmarcar todos',
  [tokens.workstation.folders.noResults]: 'Nenhuma pasta encontrada',
  [tokens.workstation.tools.title]: 'Ferramentas',
  [tokens.workstation.tools.externalSearch]: 'Buscar na Web',
  [tokens.workstation.tools.deepSearch]: 'Busca Profunda',
  [tokens.tokens.workstation.reasoning.process_steps]: 'Processo de raciocínio',
  [tokens.workstation.reasoning.tools.planner]: 'Construindo um plano de execução',
  [tokens.workstation.reasoning.tools.userFiles]: 'Procurando seus arquivos',
  [tokens.workstation.reasoning.tools.pageSearch]: 'Buscando informações nos seus documentos',
  [tokens.workstation.reasoning.tools.documentSearch]: 'Buscando no resumo do seu documento',
  [tokens.workstation.reasoning.tools.userFolders]: 'Procurando nas suas pastas',
  [tokens.workstation.reasoning.tools.videoSearch]: 'Procurando nos seus vídeos',
  [tokens.workstation.sources.errorLoadingVideo]: 'Erro ao carregar o vídeo',
  [tokens.workstation.sources.tryAgain]: 'Tentar novamente',
  [tokens.workstation.reasoning.tools.contentGenerator]: 'Gerando conteúdo',
  [tokens.workstation.reasoning.tools.queryGeneration]: 'Gerando uma consulta',
  [tokens.workstation.reasoning.tools.database]: 'Consultando o banco de dados',
  [tokens.workstation.reasoning.tools.externalSearchTool]: 'Buscando informações na Web',
  [tokens.workstation.reasoning.tools.chatHistory]: 'Buscando no histórico de conversa',
  [tokens.workstation.reasoning.tools.terminal]: 'Executando comandos no terminal',
  [tokens.workstation.reasoning.tools.analytics]: 'Analisando os dados',
  [tokens.workstation.reasoning.tools.unifiedSearch]: 'Buscando informações nos seus documentos',
  [tokens.tokens.workstation.reasoning.tools.generic]: 'Executando uma Tool',
  [tokens.workstation.loadingSuggestions]: 'Carregando sugestões...',
  [tokens.workstation.start_with_suggested_question]: 'Comece com uma pergunta sugerida:',
  [tokens.workstation.sources.show_message]: 'Mostrar mensagem',
  [tokens.workstation.message.file_search_results]: 'Resultados da busca em arquivos',
  [tokens.workstation.message.web_search_results]: 'Resultados da busca na web',
  [tokens.workstation.messages.me]: 'Eu',
  [tokens.workstation.memory.title]: 'Memória',
  [tokens.workstation.memory.subtitle]: 'Gerenciando memórias salvas durante suas conversas',
  [tokens.workstation.history.title]: 'Histórico',
  [tokens.workstation.history.subtitle]: 'Gerencie seu histórico de conversas e continue de onde parou',
  [tokens.workstation.report.columns.chat_id]: 'ID do Chat',
  [tokens.workstation.report.columns.user_message]: 'Mensagem do usuário',
  [tokens.workstation.report.columns.assistant_message]: 'Mensagem do assistente',
  [tokens.workstation.report.columns.created_at]: 'Criado em',
  [tokens.workstation.report.columns.username]: 'Nome de usuário',
  [tokens.workstation.report.columns.user_email]: 'E-mail do usuário',
  [tokens.workstation.report.download]: 'Baixar',
  [tokens.workstation.report.downloading]: 'Baixando',
  [tokens.workstation.report.truncatedContent]: '[... conteúdo truncado ...]',
  [tokens.workstation.report.toasts.reportStartGeneration.title]: 'Estamos gerando seu relatório...',
  [tokens.workstation.report.toasts.reportStartGeneration.description]: 'Aguarde enquanto processamos os dados selecionados.',
  [tokens.workstation.report.toasts.reportSuccessfulGeneration.title]: 'Relatório gerado com sucesso!',
  [tokens.workstation.report.toasts.reportSuccessfulGeneration.description]: 'O download do arquivo será iniciado em instantes.',
  [tokens.workstation.report.toasts.noDataReportGeneration.title]: 'Nenhum dado encontrado',
  [tokens.workstation.report.toasts.noDataReportGeneration.description]: 'Não há interações disponíveis para o período selecionado.',
  [tokens.workstation.report.toasts.errorOnReportGeneration.title]: 'Erro ao gerar relatório',
  [tokens.workstation.report.toasts.errorOnReportGeneration.description]: 'Ocorreu um problema ao tentar gerar o relatório. Tente novamente mais tarde.',
  [tokens.agent.executions.errors.startExecution]: 'Erro ao iniciar execução',
  [tokens.agent.executions.errors.continueExecution]: 'Erro ao continuar execução',
  [tokens.agent.executions.errors.fetchReview]: 'Erro ao buscar revisão',
  [tokens.agent.executions.errors.fetchReviewDescription]: 'Não foi possível carregar a revisão.',
  [tokens.agent.executions.review.noPendingReviews]: 'Nenhuma revisão pendente',
  [tokens.agent.executions.review.noPendingReviewsDescription]: 'Não há revisões pendentes para esta execução.',
  [tokens.agent.executions.review.notFound]: 'Revisão não encontrada',
  [tokens.agent.executions.review.notFoundDescription]: 'Não foi possível encontrar a revisão correspondente.',
  [tokens.agent.access.editAccess]: 'Editar acesso',
  [tokens.agent.access.allowedGroups]: 'Grupos permitidos',
  [tokens.agent.access.allowedUsers]: 'Usuários permitidos',
  [tokens.agent.access.selectGroups]: 'Selecionar grupos',
  [tokens.agent.access.selectUsers]: 'Selecionar usuários',
  [tokens.ui.toasts.agent.update_error.title]: 'Erro ao atualizar agente',
  [tokens.ui.toasts.agent.update_error.description]: 'Ocorreu um erro ao atualizar o agente',
  [tokens.aihub.createAgent.error.title]: 'Erro ao criar agente',
  [tokens.aihub.createAgent.error.description]: 'Não foi possível criar o agente',
  [tokens.aihub.createAssistant.error.title]: 'Erro ao criar assistente',
  [tokens.aihub.createAssistant.error.description]: 'Não foi possível criar o assistente',
  [tokens.agent.title]: 'Agente',
  [tokens.agent.subtitle]: 'Aqui está uma lista de seus agentes para gerenciá-los!',
  [tokens.agent.newAgent]: 'Novo agente',
  [tokens.agent.notFound]: 'Nenhum agente encontrado',
  [tokens.agent.search.agents]: 'Buscar agentes...',
  [tokens.agent.label.dataInput]: 'Entrada de dados',
  [tokens.agent.label.processing]: 'Processamento',
  [tokens.agent.label.dataOutput]: 'Saída de dados',
  [tokens.agent.label.howToUse]: 'Como usar: Arraste os componentes para o canvas para criar seu fluxo de trabalho.',
  [tokens.agent.label.label]: 'Rótulo',
  [tokens.agent.label.format]: 'Formato',
  [tokens.agent.label.compareDocuments]: 'Comparar Documentos',
  [tokens.agent.label.folderSelection]: 'Seleção de pasta',
  [tokens.agent.label.fileFilters]: 'Filtros de arquivo',
  [tokens.agent.label.addFilter]: 'Adicionar filtro',
  [tokens.agent.label.startsWith]: 'Começa com',
  [tokens.agent.label.endsWith]: 'Termina com',
  [tokens.agent.label.contains]: 'Contém',
  [tokens.agent.label.extensions]: 'Extensões',
  [tokens.agent.label.selectExtensions]: 'Selecionar as extensões',
  [tokens.agent.label.filePreview]: 'Visualização de arquivos',
  [tokens.agent.label.rules]: 'Regras',
  [tokens.agent.label.newRule]: 'Nova regra',
  [tokens.agent.label.outputFormat]: 'Formato de Saída',
  [tokens.agent.label.generatePDF]: 'Gerar PDF',
  [tokens.agent.executions.selectAgent]: 'Selecione um agente para ver suas execuções',
  [tokens.agent.executions.loading]: 'Buscando execuções...',
  [tokens.agent.executions.noExecutionsFound]: 'Nenhuma execução encontrada.',
  [tokens.agent.executions.columns.executionDate]: 'Data de Execução',
  [tokens.agent.executions.columns.status]: 'Status',
  [tokens.agent.executions.status.completed]: 'Concluído',
  [tokens.agent.executions.status.failed]: 'Falhou',
  [tokens.agent.executions.pagination.pageOf]: 'Página {{current}} de {{total}}',
  [tokens.agent.executions.pagination.firstPage]: 'Primeira página',
  [tokens.agent.executions.pagination.previousPage]: 'Página anterior',
  [tokens.agent.executions.pagination.nextPage]: 'Próxima página',
  [tokens.agent.executions.pagination.lastPage]: 'Última página',
  [tokens.agent.editor.ner.title]: 'Reconhecimento de Entidades',
  [tokens.agent.editor.ner.description]: 'Configure as entidades que devem ser identificadas no texto',
  [tokens.agent.editor.ner.addEntity.label]: 'Adicionar Entidade',
  [tokens.agent.editor.ner.addEntity.namePlaceholder]: 'Nome da entidade ex: Pessoa, Empresa',
  [tokens.agent.editor.ner.addEntity.descriptionPlaceholder]: 'Descrição da entidade ex: Nomes de pessoas físicas',
  [tokens.agent.editor.ner.addEntity.examples.label]: 'Exemplos',
  [tokens.agent.editor.ner.addEntity.examples.placeholder]: 'Exemplo da entidade ex: João Silva, Maria Santos',
  [tokens.agent.editor.ner.addEntity.button]: 'Adicionar Entidade',
  [tokens.agent.editor.ner.entities.label]: 'Entidades ({{count}} de {{total}})',
  [tokens.agent.editor.ner.entities.searchPlaceholder]: 'Buscar entidades por nome, descrição ou exemplos...',
  [tokens.agent.editor.ner.entities.examplesButton]: 'Exemplos ({{count}})',
  [tokens.agent.editor.ner.entities.emptyState]: 'Nenhuma entidade configurada',
  [tokens.agent.editor.ner.entities.noResultsFound]: 'Nenhuma entidade encontrada para "{{searchTerm}}"',
  [tokens.agent.editor.ner.entities.clearSearch]: 'Limpar busca',
  [tokens.agent.editor.ner.editEntity.namePlaceholder]: 'Nome da entidade',
  [tokens.agent.editor.ner.editEntity.descriptionPlaceholder]: 'Descrição da entidade',
  [tokens.agent.editor.ner.editEntity.examples.label]: 'Exemplos',
  [tokens.agent.editor.ner.editEntity.examples.placeholder]: 'Exemplo da entidade ex: João Silva, Maria Santos',
  [tokens.agent.editor.ner.editEntity.saveButton]: 'Salvar',
  [tokens.agent.editor.ner.editEntity.cancelButton]: 'Cancelar',
  [tokens.agent.editor.ner.addEntity.examples.addButton]: 'Adicionar exemplo',
  [tokens.agent.newAgent]: 'Novo agente',
  [tokens.agent.validation.messages.nerNodeNeedsEntities]: '{{nodeName}} precisa ter pelo menos uma entidade configurada',
  [tokens.agent.nodes.ner.name]: 'Extração de Entidades',
  [tokens.agent.nodes.ner.description]: 'Identifica e extrai entidades nomeadas do texto',
  [tokens.agent.editor.flowComponents]: 'Componentes do Fluxo',
  [tokens.agent.editor.nodes.input]: 'Input',
  [tokens.agent.editor.nodes.processing]: 'Processing',
  [tokens.agent.editor.nodes.output]: 'Output',
  [tokens.agent.editor.tabs.editor]: 'Editor',
  [tokens.agent.editor.tabs.executions]: 'Execuções',
  [tokens.agent.editor.agentExecutions]: 'Execuções do Agente',
  [tokens.agent.editor.editConnection]: 'Editar Conexão',
  [tokens.agent.editor.connection.from]: 'De',
  [tokens.agent.editor.connection.to]: 'Para',
  [tokens.agent.editor.recordAudio.confirmDialog.stopCurrentRecordingDescription]: 'Uma gravação está em andamento. Deseja parar a gravação no estado atual e continuar?',
  [tokens.agent.editor.recordAudio.confirmDialog.stopCurrentRecordingTip]: 'Dica: Continue usando a plataforma normalmente abrindo uma nova aba.',
  [tokens.agent.nodes.crawlerInput.name]: 'Entrada Web Crawler',
  [tokens.agent.nodes.crawlerInput.description]: 'Navega e extrai dados de páginas web usando instruções específicas',
  [tokens.agent.editor.crawlerInput.instructions]: 'Instruções de Navegação',
  [tokens.agent.editor.crawlerInput.instructionsTooltip]: 'Instruções específicas para orientar o crawler na navegação e extração de dados das páginas web',
  [tokens.agent.editor.crawlerInput.instructionPlaceholder]: 'Ex: Extrair todos os títulos das notícias da página inicial...',
  [tokens.agent.editor.crawlerInput.urls]: 'URLs Iniciais',
  [tokens.agent.editor.crawlerInput.urlsTooltip]: 'URLs opcionais para iniciar a navegação. Se não fornecidas, o crawler iniciará de acordo com as instruções',
  [tokens.agent.editor.crawlerInput.maxPages]: 'Páginas Máximas',
  [tokens.agent.editor.crawlerInput.saveFiles]: 'Salvar Arquivos',
  [tokens.agent.editor.crawlerInput.saveFilesTooltip]: 'Salva os arquivos extraídos na pasta selecionada durante a execução do crawler',
  [tokens.agent.editor.crawlerInput.outputType]: 'Tipo de saída',
  [tokens.agent.editor.crawlerInput.outputTypeTooltipTitle]: 'Tipo de saída:',
  [tokens.agent.editor.crawlerInput.outputTypeDetailed]: 'Detalhado',
  [tokens.agent.editor.crawlerInput.outputTypeSummary]: 'Resumido',
  [tokens.agent.editor.crawlerInput.outputTypeDetailedDescription]: 'Cada página será processada e retornada como um documento',
  [tokens.agent.editor.crawlerInput.outputTypeSummaryDescription]: 'O resultado será consolidado em uma única saída de texto',
  [tokens.agent.validation.messages.crawlerInputInstructionsRequired]: '{{nodeName}} precisa ter pelo menos uma instrução definida',
  [tokens.agent.validation.messages.crawlerInputEmptyInstructions]: '{{nodeName}} não pode ter instruções vazias',
  [tokens.agent.validation.messages.crawlerInputInvalidUrls]: '{{nodeName}} contém URLs inválidas',
  [tokens.agent.validation.messages.crawlerInputFolderRequired]: '{{nodeName}} precisa ter uma pasta selecionada quando \'Salvar Arquivos\' está habilitado',
  [tokens.agent.validation.messages.crawlerInputMaxPagesRange]: '{{nodeName}} deve ter entre 1 e 100 páginas máximas',
  [tokens.agent.scheduler.selectDays]: 'Selecione os dias',
  [tokens.agent.scheduler.weekDays.sunday]: 'Domingo',
  [tokens.agent.scheduler.weekDays.monday]: 'Segunda',
  [tokens.agent.scheduler.weekDays.tuesday]: 'Terça',
  [tokens.agent.scheduler.weekDays.wednesday]: 'Quarta',
  [tokens.agent.scheduler.weekDays.thursday]: 'Quinta',
  [tokens.agent.scheduler.weekDays.friday]: 'Sexta',
  [tokens.agent.scheduler.weekDays.saturday]: 'Sábado',
  [tokens.agent.scheduler.scheduleExecution]: 'Agendar execução',
  [tokens.agent.scheduler.title]: 'Agendar Execução',
  [tokens.agent.scheduler.dateAndTime]: 'Data e hora',
  [tokens.agent.scheduler.selectDateAndTime]: 'Selecione uma data e hora',
  [tokens.agent.scheduler.recurring]: 'Recorrente',
  [tokens.agent.scheduler.repeatEvery]: 'Repetir a cada',
  [tokens.agent.scheduler.select]: 'Selecione',
  [tokens.agent.scheduler.intervals.minute]: 'Minuto',
  [tokens.agent.scheduler.intervals.hour]: 'Hora',
  [tokens.agent.scheduler.intervals.day]: 'Dia',
  [tokens.agent.scheduler.intervals.week]: 'Semana',
  [tokens.agent.scheduler.intervals.month]: 'Mês',
  [tokens.agent.scheduler.intervals.year]: 'Ano',
  [tokens.agent.scheduler.daysOfWeek]: 'Dias da semana',
  [tokens.agent.scheduler.ends]: 'Termina',
  [tokens.agent.scheduler.endConditions.never]: 'Nunca',
  [tokens.agent.scheduler.endConditions.onDate]: 'Em uma data',
  [tokens.agent.scheduler.endConditions.afterOccurrences]: 'Após um número de ocorrências',
  [tokens.agent.scheduler.endDate]: 'Data de término',
  [tokens.agent.scheduler.selectDate]: 'Selecione uma data',
  [tokens.agent.scheduler.numberOfOccurrences]: 'Número de ocorrências',
  [tokens.agent.scheduler.errors.loadSchedule.title]: 'Erro ao carregar agendamento',
  [tokens.agent.scheduler.errors.loadSchedule.description ]: 'Não foi possível carregar o agendamento existente',
  [tokens.agent.scheduler.errors.scheduleExecution.title]: 'Erro ao agendar execução',
  [tokens.agent.scheduler.errors.scheduleExecution.description]: 'Ocorreu um erro ao agendar a execução do agente',
  [tokens.agent.scheduler.success.scheduleCreated.title]: 'Agendamento criado',
  [tokens.agent.scheduler.success.scheduleCreated.description]: 'O agente será executado conforme programado',
  [tokens.agent.list.errors.loadAgents.title]: 'Erro ao carregar agentes',
  [tokens.agent.list.errors.loadAgents.description]: 'Tente novamente mais tarde.',
  [tokens.agent.list.errors.deleteAgent.title]: 'Erro ao deletar agente',
  [tokens.agent.list.errors.deleteAgent.description]: 'Tente novamente mais tarde.',
  [tokens.agent.list.errors.createAgent.title]: 'Erro ao criar agente',
  [tokens.agent.list.errors.createAgent.description]: 'Tente novamente mais tarde.',
  [tokens.agent.list.success.agentActivated.title]: 'Agente ativado',
  [tokens.agent.list.success.agentActivated.description]: 'O agente foi ativado com sucesso.',
  [tokens.agent.list.success.agentDeactivated.title]: 'Agente desativado',
  [tokens.agent.list.success.agentDeactivated.description]: 'O agente foi desativado com sucesso.',
  [tokens.agent.list.status.all]: 'Todos',
  [tokens.agent.list.status.active]: 'Ativo',
  [tokens.agent.list.status.inactive]: 'Inativo',
  [tokens.agent.list.workingStatus.working]: 'Trabalhando',
  [tokens.agent.list.workingStatus.inactive]: 'Inativo',
  [tokens.agent.list.dialog.activateAgent.title]: 'Ativar Agente',
  [tokens.agent.list.dialog.activateAgent.description]: 'Tem certeza que deseja ativar este agente? Ele começará a processar tarefas automaticamente.',
  [tokens.agent.list.dialog.activateAgent.confirmText]: 'Ativar',
  [tokens.agent.list.dialog.deactivateAgent.title]: 'Desativar Agente',
  [tokens.agent.list.dialog.deactivateAgent.description]: 'Tem certeza que deseja desativar este agente? Ele parará de processar tarefas automaticamente.',
  [tokens.agent.list.dialog.deactivateAgent.confirmText]: 'Desativar',
  [tokens.agent.list.success.agentScheduledImmediate ]: 'O agente foi executado imediatamente',
  [tokens.agent.list.success.agentScheduled.title]: 'Agente agendado com sucesso',
  [tokens.agent.list.success.agentScheduled.description]: 'O agente será ativado no horário programado',
  [tokens.agent.list.dialog.activateAgent.chooseOption]: 'Escolha como deseja ativar o agente',
  [tokens.agent.list.dialog.activateAgent.executeNow]: 'Executar Agora',
  [tokens.agent.list.dialog.activateAgent.schedule]: 'Agendar',
  [tokens.agent.editor.availableNodes.searchPlaceholder.input]: 'Buscar nós de entrada...',
  [tokens.agent.editor.availableNodes.searchPlaceholder.processing]: 'Buscar nós de processamento...',
  [tokens.agent.editor.availableNodes.searchPlaceholder.output]: 'Buscar nós de saída...',
  [tokens.agent.editor.availableNodes.loading]: 'Carregando...',
  [tokens.agent.editor.availableNodes.noResultsFound]: 'Nenhum resultado encontrado',
  [tokens.agent.label.placeholderLabel]: 'Nome do nó',
  [tokens.agent.label.selectFolder]: 'Selecionar pasta',
  [tokens.agent.editor.inputFolder.loadingFolders]: 'Carregando pastas...',
  [tokens.agent.editor.inputFolder.noFoldersFound]: 'Nenhuma pasta encontrada',
  [tokens.agent.editor.inputFolder.selectFolderFirst]: 'Selecione uma pasta primeiro',
  [tokens.agent.editor.inputFolder.selectFolderToPreview]: 'Selecione uma pasta para visualizar os arquivos',
  [tokens.agent.editor.inputFolder.loading]: 'Carregando...',
  [tokens.agent.editor.inputFolder.noFilesFound]: 'Nenhum arquivo encontrado',
  [tokens.agent.editor.textInput.editContent]: 'Editar Conteúdo',
  [tokens.agent.editor.textInput.addContent]: 'Adicionar Conteúdo',
  [tokens.agent.editor.textInput.preview]: 'Prévia',
  [tokens.agent.editor.textInput.contentLabel]: 'Conteúdo de Texto',
  [tokens.agent.editor.textInput.contentPlaceholder]: 'Digite o texto aqui...',
  [tokens.agent.editor.consoleOutput.checkConsoleMessage]: 'Confira o console para ver o resultado',
  [tokens.agent.editor.llmGenerate.agentCharacteristics]: 'Características do Agente',
  [tokens.agent.editor.llmGenerate.personality.label]: 'Personalidade',
  [tokens.agent.editor.llmGenerate.personality.placeholder]: 'Ex: Assistente prestativo e conhecedor...',
  [tokens.agent.editor.llmGenerate.role.label]: 'Função',
  [tokens.agent.editor.llmGenerate.role.placeholder]: 'Ex: Assistente de redação, Analista de dados...',
  [tokens.agent.editor.llmGenerate.instructions.label]: 'Instruções',
  [tokens.agent.editor.llmGenerate.instructions.placeholder]: 'Adicionar nova instrução...',
  [tokens.agent.editor.llmGenerate.toneLabel]: 'Tom',
  [tokens.agent.editor.llmGenerate.tonePlaceholder]: 'Selecione o tom de comunicação',
  [tokens.agent.editor.llmGenerate.languageLabel]: 'Idioma',
  [tokens.agent.editor.llmGenerate.languagePlaceholder]: 'Selecione o idioma de comunicação',
  [tokens.agent.editor.llmGenerate.abilitiesLabel]: 'Habilidades',
  [tokens.agent.editor.llmGenerate.tone.professional]: 'Profissional',
  [tokens.agent.editor.llmGenerate.tone.casual]: 'Casual',
  [tokens.agent.editor.llmGenerate.tone.friendly]: 'Amigável',
  [tokens.agent.editor.llmGenerate.tone.formal]: 'Formal',
  [tokens.agent.editor.llmGenerate.language.auto]: 'Automático',
  [tokens.agent.editor.llmGenerate.language.english]: 'Inglês',
  [tokens.agent.editor.llmGenerate.language.portuguese]: 'Português',
  [tokens.agent.editor.llmGenerate.language.spanish]: 'Espanhol',
  [tokens.agent.editor.llmGenerate.language.french]: 'Francês',
  [tokens.agent.editor.llmGenerate.language.italian]: 'Italiano',
  [tokens.agent.editor.llmGenerate.abilities.fileSearch]: 'Busca em Arquivos',
  [tokens.agent.editor.llmGenerate.abilities.webSearch]: 'Busca na Web',
  [tokens.agent.editor.llmGenerate.abilities.planning]: 'Planejamento',
  [tokens.agent.editor.llmGenerate.abilities.imageAnalysis]: 'Análise de Imagens',
  [tokens.agent.editor.llmGenerate.instructions.title]: 'Editor de Instruções',
  [tokens.agent.editor.textTranslator.requireReview.label]: 'Requer Revisão',
  [tokens.agent.editor.textTranslator.requireReview.tooltip]: 'Quando ativado, as traduções serão enviadas para revisão antes de serem finalizadas',
  [tokens.agent.editor.textTranslator.glossary.updateButton]: 'Atualizar',
  [tokens.agent.editor.textTranslator.glossary.addButton]: 'Adicionar',
  [tokens.agent.editor.textTranslator.glossary.cancelEditButton]: 'Cancelar edição',
  [tokens.agent.editor.textTranslator.editInstructions]: 'Editar Instruções',
  [tokens.agent.editor.textTranslator.addInstructions]: 'Adicionar Instruções',
  [tokens.agent.editor.llmGenerate.instructions.addButton]: 'Adicionar Instrução',
  [tokens.agent.editor.textTranslator.sourceLanguageLabel]: 'Idioma de Origem',
  [tokens.agent.editor.textTranslator.sourceLanguagePlaceholder]: 'Selecione o idioma de origem',
  [tokens.agent.editor.textTranslator.targetLanguageLabel]: 'Idioma de Destino',
  [tokens.agent.editor.textTranslator.targetLanguagePlaceholder]: 'Selecione o idioma de destino',
  [tokens.agent.editor.textTranslator.instructionsLabel]: 'Instruções de Tradução',
  [tokens.agent.editor.textTranslator.instructionsPlaceholder]: 'Instruções específicas para a tradução (tom, estilo, contexto, etc.)...',
  [tokens.agent.editor.textTranslator.language.english]: 'Inglês',
  [tokens.agent.editor.textTranslator.language.portuguese]: 'Português',
  [tokens.agent.editor.textTranslator.language.spanish]: 'Espanhol',
  [tokens.agent.editor.textTranslator.language.french]: 'Francês',
  [tokens.agent.editor.textTranslator.language.italian]: 'Italiano',
  [tokens.agent.editor.textTranslator.glossary.label]: 'Glossário',
  [tokens.agent.editor.textTranslator.glossary.termPlaceholder]: 'Termo a ser substituído',
  [tokens.agent.editor.textTranslator.glossary.translationPlaceholder]: 'Tradução a ser usada',
  [tokens.agent.editor.textTranslator.glossary.tooltipTerm]: 'Termo:',
  [tokens.agent.editor.textTranslator.glossary.tooltipTranslation]: 'Tradução:',
  [tokens.agent.editor.textTranslator.glossary.searchPlaceholder]: 'Procurar termo...',
  [tokens.agent.editor.textTranslator.glossary.noResultsFound]: 'Nenhum resultado encontrado para {{searchTerm}}',
  [tokens.agent.editor.textTranslator.glossary.noResultsHint]: 'Tente buscar por outros termos ou traduções',
  [tokens.agent.editor.textTranslator.glossary.emptyGlossary]: 'Nenhum termo no glossário',
  [tokens.agent.editor.textTranslator.glossary.emptyGlossaryHint]: 'Adicione termos usando os campos acima',
  [tokens.agent.editor.textTranslator.glossary.editingItem]: 'Editando item {{index}}',
  [tokens.agent.editor.formatTemplate.templateLabel]: 'Template de Formatação',
  [tokens.agent.editor.formatTemplate.tagLabel]: 'Tag do Template',
  [tokens.agent.editor.formatTemplate.tagPlaceholder]: 'Digite uma tag para identificar o template',
  [tokens.agent.editor.formatTemplate.tagTooltip]: 'A tag ajuda a identificar e organizar o template',
  [tokens.agent.editor.formatTemplate.dragAndDropText]: 'Arraste um arquivo aqui ou clique para selecionar',
  [tokens.agent.editor.formatTemplate.fileSize]: 'Tamanho',
  [tokens.agent.editor.formatTemplate.uploading]: 'Enviando...',
  [tokens.agent.editor.formatTemplate.sendTemplate]: 'Enviar Template',
  [tokens.agent.editor.formatTemplate.cancel]: 'Cancelar',
  [tokens.agent.editor.formatTemplate.replaceTemplate]: 'Substituir Template',
  [tokens.agent.editor.formatTemplate.tooltip.supportedFormats]: 'Formatos suportados:',
  [tokens.agent.editor.formatTemplate.tooltip.formats]: 'DOCX DOC PDF',
  [tokens.agent.editor.formatTemplate.tooltip.maxSize]: 'Tamanho máximo: 50MB',
  [tokens.agent.editor.formatTemplate.success.templateSent]: 'Template enviado com sucesso',
  [tokens.agent.editor.formatTemplate.success.templateReplaced]: 'Template substituído com sucesso',
  [tokens.agent.editor.formatTemplate.errors.fileTooLarge.title]: 'Arquivo muito grande',
  [tokens.agent.editor.formatTemplate.errors.fileTooLarge.description]: 'O arquivo {{fileName}} excede o limite de {{maxSize}} MB e não pode ser enviado.',
  [tokens.agent.editor.formatTemplate.errors.unsupportedFormat.title]: 'Formato não suportado',
  [tokens.agent.editor.formatTemplate.errors.unsupportedFormat.description]: 'O formato do arquivo não é suportado. Use apenas: {{formats}}',
  [tokens.agent.editor.formatTemplate.errors.uploadError.title]: 'Erro ao enviar template',
  [tokens.agent.editor.formatTemplate.errors.uploadError.description]: 'Ocorreu um erro ao enviar o template. Tente novamente.',
  [tokens.agent.editor.splitDocument.splitMode.label]: 'Modo de Divisão',
  [tokens.agent.editor.splitDocument.splitMode.placeholder]: 'Selecione o modo de divisão',
  [tokens.agent.editor.splitDocument.splitMode.auto]: 'Automático',
  [tokens.agent.editor.splitDocument.splitMode.ranges]: 'Intervalos de Páginas',
  [tokens.agent.editor.splitDocument.splitMode.rangesDescription]: 'Divide o documento em intervalos ou páginas específicas',
  [tokens.agent.editor.splitDocument.pages.label]: 'Páginas',
  [tokens.agent.editor.splitDocument.pages.tooltip]: 'Dividir da página {{start}} até {{end}}',
  [tokens.agent.editor.splitDocument.auto.title]: 'Divisão Inteligente',
  [tokens.agent.editor.splitDocument.auto.description]: 'Identifica os melhores pontos de corte automaticamente.',
  [tokens.agent.editor.extractContent.textExtraction]: 'Extração de Texto',
  [tokens.agent.editor.extractContent.extractText]: 'Extrair texto dos documentos',
  [tokens.agent.editor.extractContent.imageExtraction]: 'Extração de Imagens',
  [tokens.agent.editor.extractContent.extractImages]: 'Extrair imagens dos documentos',
  [tokens.agent.editor.recordAudio.title]: 'Gravação de Áudio',
  [tokens.agent.editor.recordAudio.tooltip]: 'Grave áudio do microfone e da tela selecionada',
  [tokens.agent.editor.recordAudio.fileInfo.size]: 'Tamanho',
  [tokens.agent.editor.recordAudio.fileInfo.duration]: 'Duração',
  [tokens.agent.editor.recordAudio.browserSupport.apisNotSupported]: 'Navegador não compatível',
  [tokens.agent.editor.recordAudio.browserSupport.mediaDevicesNotSupported]: 'Seu navegador não suporta acesso a dispositivos de mídia.',
  [tokens.agent.editor.recordAudio.browserSupport.featuresNotSupported]: 'Recursos não suportados',
  [tokens.agent.editor.recordAudio.browserSupport.microphoneNotSupported]: 'Seu navegador não suporta acesso ao microfone.',
  [tokens.agent.editor.recordAudio.browserSupport.screenShareNotSupported]: 'Seu navegador não suporta compartilhamento de tela.',
  [tokens.agent.editor.recordAudio.browserSupport.mediaRecorderNotSupported]: 'Seu navegador não suporta gravação de mídia.',
  [tokens.agent.editor.recordAudio.permissions.permissionRequired]: 'Permissão necessária',
  [tokens.agent.editor.recordAudio.permissions.allowMicrophoneAccess]: 'Permita o acesso ao microfone para continuar...',
  [tokens.agent.editor.recordAudio.permissions.selectArea]: 'Selecione a área',
  [tokens.agent.editor.recordAudio.permissions.selectScreenForAudio]: 'Agora selecione a tela/janela para gravar o áudio...',
  [tokens.agent.editor.recordAudio.screenAudio.screenAudioNotAvailable]: 'Áudio da tela não disponível',
  [tokens.agent.editor.recordAudio.screenAudio.shareAudioCheckbox]: 'Certifique-se de marcar \'Compartilhar áudio\' na janela de seleção.',
  [tokens.agent.editor.recordAudio.upload.uploadError]: 'Erro no upload',
  [tokens.agent.editor.recordAudio.upload.failedToSendAudio]: 'Falha ao enviar o arquivo de áudio.',
  [tokens.agent.editor.recordAudio.upload.recordingSent]: 'Gravação enviada',
  [tokens.agent.editor.recordAudio.upload.audioFileSentSuccessfully]: 'O arquivo de áudio foi enviado com sucesso.',
  [tokens.agent.editor.recordAudio.recording.recordingError]: 'Erro na gravação',
  [tokens.agent.editor.recordAudio.recording.noAudioDataCaptured]: 'Nenhum dado de áudio foi capturado.',
  [tokens.agent.editor.recordAudio.recording.recordingStarted]: 'Gravação iniciada',
  [tokens.agent.editor.recordAudio.recording.recordingMicrophoneAndScreen]: 'Gravando áudio do microfone e da tela selecionada.',
  [tokens.agent.editor.recordAudio.errors.permissionDenied]: 'Permissão negada',
  [tokens.agent.editor.recordAudio.errors.allowMicrophoneAndScreenAccess]: 'Permita acesso ao microfone e compartilhamento de tela para continuar.',
  [tokens.agent.editor.recordAudio.errors.deviceNotFound]: 'Dispositivo não encontrado',
  [tokens.agent.editor.recordAudio.errors.microphoneOrScreenNotFound]: 'Microfone ou tela não encontrados.',
  [tokens.agent.editor.recordAudio.errors.recordingCancelled]: 'Gravação cancelada',
  [tokens.agent.editor.recordAudio.errors.selectionCancelledByUser]: 'A seleção foi cancelada pelo usuário.',
  [tokens.agent.editor.recordAudio.errors.unknownErrorStartingRecording]: 'Erro desconhecido ao iniciar gravação, verifique se o navegador suporta a gravação de áudio e tela.',
  [tokens.agent.editor.recordAudio.actions.startRecording]: 'Iniciar Gravação',
  [tokens.agent.editor.recordAudio.actions.stopRecording]: 'Parar Gravação',
  [tokens.agent.editor.recordAudio.confirmDialog.newRecording]: 'Nova Gravação',
  [tokens.agent.editor.recordAudio.confirmDialog.previousRecordingWillBeLost]: 'Ao iniciar uma nova gravação, a gravação anterior será perdida permanentemente. Deseja iniciar uma nova gravação?',
  [tokens.agent.editor.recordAudio.confirmDialog.yes]: 'Sim',
  [tokens.agent.editor.recordAudio.browserNotSupported]: 'Seu navegador não suporta o elemento de áudio.',
  [tokens.agent.nodes.audioTranscription.name]: 'Transcrição de Áudio',
  [tokens.agent.nodes.audioTranscription.description]: 'Transcreve arquivos de áudio para texto',
  [tokens.agent.editor.audioTranscription.audioLanguage.label]: 'Idioma do Áudio',
  [tokens.agent.editor.audioTranscription.audioLanguage.placeholder]: 'Selecione o idioma',
  [tokens.agent.editor.audioTranscription.audioLanguage.description]: 'Idioma do arquivo de áudio que será transcrito. Informar o idioma correto melhora significativamente a precisão e qualidade da transcrição, reduzindo erros de interpretação.',
  [tokens.agent.editor.audioTranscription.language.portuguese]: 'Português',
  [tokens.agent.editor.audioTranscription.language.english]: 'Inglês',
  [tokens.agent.editor.audioTranscription.language.spanish]: 'Espanhol',
  [tokens.agent.editor.audioTranscription.language.french]: 'Francês',
  [tokens.agent.editor.audioTranscription.language.italian]: 'Italiano',
  [tokens.agent.validation.messages.audioTranscriptionNodeNeedsLanguage]: 'O node {nodeName} precisa ter um idioma de áudio configurado',
  [tokens.agent.nodes.generateReport.name]: 'Gerar Relatório',
  [tokens.agent.nodes.generateReport.description]: 'Gera relatórios estruturados com base nos dados de entrada',
  [tokens.agent.editor.generateReport.instructions.label]: 'Instruções para o Relatório',
  [tokens.agent.editor.generateReport.instructions.placeholder]: 'Digite instruções específicas para a geração do relatório...',
  [tokens.agent.editor.generateReport.instructions.description]: 'Instruções específicas que orientarão a geração do relatório, como formato, estilo ou requisitos especiais',
  [tokens.agent.editor.generateReport.reportOptions.label]: 'Opções do Relatório',
  [tokens.agent.editor.generateReport.reportOptions.summary]: 'Incluir Resumo',
  [tokens.agent.editor.generateReport.reportOptions.importantDates]: 'Incluir Datas Importantes',
  [tokens.agent.editor.generateReport.reportOptions.tasks]: 'Incluir Tarefas',
  [tokens.agent.editor.generateReport.reportOptions.conclusion]: 'Incluir Conclusão',
  [tokens.agent.editor.generateReport.reportOptions.chartGeneration]: 'Habilitar Geração de Gráficos',
  [tokens.agent.nodes.recordAudio.name]: 'Gravação de Áudio',
  [tokens.agent.nodes.recordAudio.description]: 'Permite gravar áudio diretamente no navegador',
  [tokens.agent.nodes.formatTemplate.name]: 'Formatação de Template',
  [tokens.agent.nodes.formatTemplate.description]: 'Formata conteúdo usando templates',
  [tokens.agent.nodes.extractContent.name]: 'Extração de Conteúdo',
  [tokens.agent.nodes.extractContent.description]: 'Extrai o conteúdo de documentos com base em regras fornecidas',
  [tokens.agent.console.title]: 'Console de Resultados',
  [tokens.agent.console.status.label]: 'Status',
  [tokens.agent.console.status.error]: 'Erro',
  [tokens.agent.console.status.completed]: 'Concluído',
  [tokens.agent.console.status.processing]: 'Processando',
  [tokens.agent.console.status.connected]: 'Conectado',
  [tokens.agent.console.status.quotaExceeded]: 'Quota Excedida',
  [tokens.agent.console.waitingForProcessing]: 'Aguardando processamento...',
  [tokens.agent.console.totalMessages]: 'Total de mensagens',
  [tokens.agent.console.stopButton]: 'Parar',
  [tokens.agent.controls.unsavedChanges]: 'Alterações não salvas',
  [tokens.agent.controls.saveTooltip]: 'Salvar no servidor',
  [tokens.agent.controls.saving]: 'Salvando...',
  [tokens.agent.controls.saved]: 'Salvo!',
  [tokens.agent.controls.saveError]: 'Erro ao salvar',
  [tokens.agent.controls.save]: 'Salvar',
  [tokens.agent.controls.stopExecution]: 'Parar execução',
  [tokens.agent.controls.startExecution]: 'Iniciar execução',
  [tokens.agent.nodes.defaultInputNode]: 'Nó de entrada',
  [tokens.agent.nodes.selectInputNode]: 'Selecione um nó de entrada',
  [tokens.agent.nodes.defaultProcessingNode]: 'Nó de processamento',
  [tokens.agent.nodes.selectProcessingNode]: 'Selecione um nó de processamento',
  [tokens.agent.nodes.defaultOutputNode]: 'Nó de saída',
  [tokens.agent.nodes.selectOutputNode]: 'Selecione um nó de saída',
  [tokens.agent.nodes.defaultNode]: 'Nó',
  [tokens.agent.nodes.label.resultType]: 'Tipo de Resultado',
  [tokens.agent.nodes.label.attachment]: 'Anexo',
  [tokens.agent.nodes.label.body]: 'Corpo do Email',
  [tokens.agent.dragDrop.errorAddingNode]: 'Erro ao adicionar nó',
  [tokens.agent.websocket.startingConnection]: 'Iniciando conexão...',
  [tokens.agent.websocket.errorAgentIdNotSpecified]: 'Erro: ID do agente não especificado',
  [tokens.agent.websocket.errorProcessingMessage]: 'Erro ao processar mensagem',
  [tokens.agent.websocket.errorConnectingToServer]: 'Erro ao conectar com o servidor',
  [tokens.agent.websocket.connectionClosed]: 'Conexão fechada',
  [tokens.agent.websocket.connectionInterrupted]: 'Conexão interrompida',
  [tokens.agent.websocket.executionCompletedSuccess]: 'Execução finalizada com sucesso',
  [tokens.agent.websocket.executionCompletedError]: 'Execução finalizada com erro',
  [tokens.agent.websocket.quotaInsufficient]: 'Quota insuficiente',
  [tokens.agent.flow.errorReloadingData]: 'Erro ao recarregar dados',
  [tokens.agent.flow.couldNotUpdateDataAfterStop]: 'Não foi possível atualizar os dados após parar a execução',
  [tokens.agent.flow.errorOnSave]: 'Erro ao salvar',
  [tokens.agent.flow.couldNotStartExecution]: 'Não foi possível iniciar a execução',
  [tokens.agent.flow.agentNamePlaceholder]: 'Nome do agente',
  [tokens.agent.workflow.errorLoadingAgent]: 'Erro ao carregar agente',
  [tokens.agent.workflow.pleaseTryAgain]: 'Tente novamente',
  [tokens.agent.loading.loadingFlowFromServer]: 'Carregando fluxo do servidor...',
  [tokens.agent.nodes.inputFolder.name]: 'Entrada de Pasta',
  [tokens.agent.nodes.inputFolder.description]: 'Nó para processar entradas de pastas e recuperar arquivos',
  [tokens.agent.nodes.textInput.name]: 'Entrada de Texto Simples',
  [tokens.agent.nodes.textInput.description]: 'Um nó de entrada simples que recebe um texto',
  [tokens.agent.nodes.documentComparison.name]: 'Comparação de documentos',
  [tokens.agent.nodes.documentComparison.description]: 'Um nó que compara documentos baseado em regras fornecidas e gera um relatório de comparação em HTML',
  [tokens.agent.nodes.textTranslator.name]: 'Tradução de Texto',
  [tokens.agent.nodes.textTranslator.description]: 'Um nó que traduz texto entre diferentes idiomas usando IA',
  [tokens.agent.nodes.llmGenerate.name]: 'Geração de Texto',
  [tokens.agent.nodes.llmGenerate.description]: 'Um nó personalizável para geração de texto com LLM com características de agente e capacidades configuráveis',
  [tokens.agent.nodes.outputFolder.name]: 'Salvar Resultados em Pasta',
  [tokens.agent.nodes.outputFolder.description]: 'Nó de saída para salvar arquivos em pastas',
  [tokens.agent.nodes.consoleOutput.name]: 'Log no Console',
  [tokens.agent.nodes.consoleOutput.description]: 'Um nó de saída simples que registra o resultado no console',
  [tokens.agent.nodes.splitDocument.name]: 'Divisão de Documentos',
  [tokens.agent.nodes.splitDocument.description]: 'Nó para dividir documentos em partes menores',
  [tokens.agent.validation.hasValidationWarnings]: 'Há avisos de validação',
  [tokens.agent.validation.workflowValid]: 'Workflow válido',
  [tokens.agent.validation.warningsClickToSeeDetails]: 'Ver detalhes',
  [tokens.agent.validation.warnings]: 'Avisos',
  [tokens.agent.validation.nodeTypes.textInput]: 'Nó de entrada de texto',
  [tokens.agent.validation.nodeTypes.inputFolder]: 'Nó de entrada de pasta',
  [tokens.agent.validation.nodeTypes.outputFolder]: 'Nó de saída de pasta',
  [tokens.agent.validation.nodeTypes.consoleOutput]: 'Nó de saída do console',
  [tokens.agent.validation.nodeTypes.textTranslator]: 'Nó de tradução',
  [tokens.agent.validation.nodeTypes.llmGenerate]: 'Nó de geração LLM',
  [tokens.agent.validation.nodeTypes.documentComparison]: 'Nó de comparação de documentos',
  [tokens.agent.validation.nodeTypes.formatTemplate]: 'Nó de formatação de templates',
  [tokens.agent.validation.nodeTypes.extractContent]: 'Nó de extração de conteúdo',
  [tokens.agent.validation.nodeTypes.input]: 'Nó de entrada',
  [tokens.agent.validation.nodeTypes.processing]: 'Nó de processamento',
  [tokens.agent.validation.nodeTypes.output]: 'Nó de saída',
  [tokens.agent.validation.nodeTypes.inputFile]: 'Nó de entrada de arquivo',
  [tokens.agent.validation.nodeTypes.node]: 'Nó',
  [tokens.agent.validation.messages.agentNameRequired]: 'Nome do agente precisa ser definido',
  [tokens.agent.validation.messages.workflowNeedsNodes]: 'O workflow precisa ter pelo menos um nó',
  [tokens.agent.validation.messages.workflowNeedsInputNodes]: 'O workflow precisa ter pelo menos um nó de entrada',
  [tokens.agent.validation.messages.workflowNeedsOutputNodes]: 'O workflow precisa ter pelo menos um nó de saída',
  [tokens.agent.validation.messages.nodeLabelRequired]: '{{nodeName}} precisa ter um rótulo definido',
  [tokens.agent.validation.messages.nodeNotConnected]: '{{nodeName}} não está conectado ao workflow',
  [tokens.agent.validation.messages.nodeNeedsInput]: '{{nodeName}} precisa ter pelo menos uma entrada',
  [tokens.agent.validation.messages.nodeNeedsOutput]: '{{nodeName}} precisa ter pelo menos uma saída',
  [tokens.agent.validation.messages.workflowCannotHaveCycles]: 'O workflow não pode ter ciclos (referências circulares)',
  [tokens.agent.validation.messages.nodeNotConfigured]: '{{nodeName}} não está configurado. Escolha um tipo para configurar.',
  [tokens.agent.validation.messages.textInputCannotBeEmpty]: '{{nodeName}} não pode estar vazio',
  [tokens.agent.validation.messages.folderNodeNeedsFolder]: '{{nodeName}} precisa ter uma pasta selecionada',
  [tokens.agent.validation.messages.translatorNodeNeedsConfig]: '{{nodeName}} precisa estar configurado',
  [tokens.agent.validation.messages.translatorNodeNeedsSourceLanguage]: '{{nodeName}} precisa ter o idioma de origem definido',
  [tokens.agent.validation.messages.translatorNodeNeedsTargetLanguage]: '{{nodeName}} precisa ter o idioma de destino definido',
  [tokens.agent.validation.messages.translatorNodeNeedsDifferentLanguages]: '{{nodeName}} precisa ter idiomas de origem e destino diferentes',
  [tokens.agent.validation.messages.llmNodeNeedsConfig]: '{{nodeName}} precisa estar configurado',
  [tokens.agent.validation.messages.llmNodeNeedsInstructions]: '{{nodeName}} precisa ter pelo menos uma instrução definida',
  [tokens.agent.validation.messages.formatTemplateNeedsTag]: '{{nodeName}} precisa ter uma tag definida',
  [tokens.agent.validation.messages.formatTemplateNeedsFile]: '{{nodeName}} precisa ter um template enviado',
  [tokens.agent.validation.messages.splitDocumentNeedsRanges]: '{{nodeName}} precisa ter pelo menos um intervalo definido quando o modo "Intervalos de Páginas" está selecionado',
  [tokens.agent.validation.messages.extractContentNeedsSelection]: '{{nodeName}} precisa ter pelo menos uma opção de extração selecionada',
  [tokens.agent.validation.nodeTypes.restApiOutput]: 'Nó de Saída REST API',
  [tokens.agent.validation.messages.restApiNodeNeedsUrl]: '{{nodeName}} precisa de uma URL válida',
  [tokens.agent.validation.messages.restApiNodeNeedsMethod]: '{{nodeName}} precisa de um método HTTP',
  [tokens.agent.validation.messages.restApiNodeNeedsValidTimeout]: 'O timeout do nó {{nodeName}} deve estar entre 1000 e 30000 ms',
  [tokens.agent.validation.messages.recordAudioNeedsFile]: '{{nodeName}} precisa de uma gravação de áudio',
  [tokens.executionNodeData.noDataAvailable]: 'Nenhum dado disponível',
  [tokens.executionNodeData.input]: 'Entrada',
  [tokens.executionNodeData.output]: 'Saída',
  [tokens.executionNodeData.noInputOutputData]: 'Nenhum dado de input ou output disponível para este nó.',
  [tokens.agent.executions.status.skipped]: 'Não executado',
  [tokens.agent.editor.fileInput.fileLabel]: 'Arquivo',
  [tokens.agent.editor.fileInput.tooltip.supportedFormats]: 'Formatos suportados:',
  [tokens.agent.editor.fileInput.tooltip.maxSize]: 'Tamanho máximo: 50MB',
  [tokens.agent.editor.fileInput.fileSize]: 'Tamanho',
  [tokens.agent.editor.fileInput.sendFile]: 'Enviar arquivo',
  [tokens.agent.editor.fileInput.uploading]: 'Enviando...',
  [tokens.agent.editor.fileInput.cancel]: 'Cancelar',
  [tokens.agent.editor.fileInput.replaceFile]: 'Substituir arquivo',
  [tokens.agent.editor.fileInput.success.fileSent]: 'Arquivo enviado com sucesso',
  [tokens.agent.editor.fileInput.errors.unsupportedFormat.title]: 'Formato não suportado',
  [tokens.agent.editor.fileInput.errors.fileTooLarge.title]: 'Arquivo muito grande',
  [tokens.agent.editor.fileInput.errors.fileTooLarge.description]: 'O arquivo excede o tamanho máximo de 50MB.',
  [tokens.agent.editor.fileInput.errors.uploadError.title]: 'Erro no upload',
  [tokens.agent.editor.fileInput.errors.uploadError.description]: 'Ocorreu um erro ao enviar o arquivo. Tente novamente.',
  [tokens.agent.editor.changeNodeType]: 'Alterar o tipo do nó',
  [tokens.agent.nodes.fileInput.name]: 'Entrada de Arquivo',
  [tokens.agent.nodes.fileInput.description]: 'Recebe um arquivo como entrada para o workflow',
  [tokens.agent.validation.messages.fileInputNeedsFile]: '{{nodeName}} precisa de um arquivo selecionado',
  [tokens.agent.editor.fileInput.errors.unsupportedFormat.description]: 'O formato do arquivo não é suportado. Use apenas: {{formats}}',
  [tokens.agent.nodes.restApiOutput.name]: 'Saída REST API',
  [tokens.agent.nodes.restApiOutput.description]: 'Envia dados para uma API REST externa',
  [tokens.agent.label.restApiConfiguration]: 'Configuração da API REST',
  [tokens.agent.label.url]: 'URL',
  [tokens.agent.label.method]: 'Método',
  [tokens.agent.label.timeout]: 'Timeout (ms)',
  [tokens.agent.label.headers]: 'Cabeçalhos',
  [tokens.agent.label.headerKey]: 'Chave',
  [tokens.agent.label.headerValue]: 'Valor',
  [tokens.agent.nodes.emailOutput.name]: 'Saída de Email',
  [tokens.agent.nodes.emailOutput.description]: 'Envia resultados por email para destinatários especificados',
  [tokens.agent.label.emailConfiguration]: 'Configuração de Email',
  [tokens.agent.label.recipients]: 'Destinatários',
  [tokens.agent.label.subject]: 'Assunto',
  [tokens.agent.label.addRecipient]: 'Adicionar Destinatário',
  [tokens.agent.label.removeRecipient]: 'Remover Destinatário',
  [tokens.agent.validation.messages.emailNodeNeedsRecipients]: '{{nodeName}} precisa de pelo menos um destinatário',
  [tokens.agent.validation.messages.emailNodeNeedsValidEmails]: '{{nodeName}} precisa de endereços de email válidos',
  [tokens.agent.validation.nodeTypes.emailOutput]: 'Nó de Saída de Email',
  [tokens.agent.editor.textTranslator.review.title]: 'Revisão do Tradutor de Texto',
  [tokens.agent.editor.textTranslator.review.success.title]: 'Sucesso',
  [tokens.agent.editor.textTranslator.review.success.description]: 'Revisão enviada com sucesso',
  [tokens.agent.editor.textTranslator.review.error.title]: 'Erro',
  [tokens.agent.editor.textTranslator.review.error.description]: 'Falha ao enviar revisão. Tente novamente.',
  [tokens.agent.editor.textTranslator.review.reprocessTooltip]: 'Reprocessar tradução',
  [tokens.agent.editor.textTranslator.review.rejectButton]: 'Rejeitar',
  [tokens.agent.editor.textTranslator.review.approveButton]: 'Confirmar',
  [tokens.agent.editor.textTranslator.reprocess.title]: 'Reprocessar',
  [tokens.agent.editor.textTranslator.reprocess.placeholder]: 'Descreva o que precisa ser corrigido na tradução...',
  [tokens.agent.editor.textTranslator.reprocess.cancel]: 'Cancelar',
  [tokens.agent.editor.textTranslator.reprocess.button]: 'Reprocessar',
  [tokens.agent.editor.recordAudio.sendToWorkstationTooltip]: 'Salve o áudio gravado na workstation\npara usar em conversas futuras com o Alan',
  [tokens.agent.editor.recordAudio.sendToWorkstation]: 'Enviar para Workstation',
  [tokens.agent.executions.continueStarted.title]: 'Execução continuada',
  [tokens.agent.executions.continueStarted.description]: 'A execução foi continuada com sucesso.',
  [tokens.agent.executions.errors.continueError]: 'Erro ao continuar execução',
  [tokens.agent.executions.errors.unknownError]: 'Erro desconhecido',
  [tokens.agent.executions.status.notExecuted]: 'Não executado',
  [tokens.agent.executions.review.pending]: 'Revisão pendente',
  [tokens.agent.websocket.reviewRequired]: 'Revisão necessária',
  [tokens.agent.executions.errorFetchingPendingReviews]: 'Falha ao buscar revisões pendentes',
  [tokens.agent.executions.tryAgainLater]: 'Tente novamente mais tarde',
  [tokens.agent.executions.status.review]: 'Revisão',
  [tokens.agent.executions.status.canceled]: 'Cancelado',
  [tokens.agent.editor.textTranslator.documentViewer.notSupported]: 'Visualização não suportada no momento',
  [tokens.agent.editor.textTranslator.documentViewer.format]: 'Formato',
  [tokens.agent.editor.textTranslator.documentViewer.title]: 'Visualizador de Documento',
  [tokens.agent.editor.textTranslator.glossary.editTitle]: 'Editar Glossário',
  [tokens.agent.editor.textTranslator.glossary.addTitle]: 'Adicionar Glossário',
  [tokens.agent.editor.textTranslator.glossary.termsLabel]: 'Termos',
  [tokens.agent.editor.textTranslator.glossary.removeTerm]: 'Remover termo',
  [tokens.agent.editor.textTranslator.glossary.closeButton]: 'Fechar',
  [tokens.agent.editor.textTranslator.glossary.saveButton]: 'Salvar',
  [tokens.agent.editor.textTranslator.glossary.searchPlaceholder]: 'Procurar termo...',
  [tokens.agent.editor.textTranslator.glossary.loadingGlossaries]: 'Carregando glossários...',
  [tokens.agent.editor.textTranslator.glossary.editAction]: 'Editar',
  [tokens.agent.editor.textTranslator.glossary.duplicateAction]: 'Duplicar',
  [tokens.agent.editor.textTranslator.glossary.deleteAction]: 'Deletar',
  [tokens.agent.editor.textTranslator.glossary.deleteConfirmTitle]: 'Deletar glossário?',
  [tokens.agent.editor.textTranslator.glossary.deleteConfirmDescription]: 'Esta ação deletará o glossário selecionado. Não é possível desfazer.',
  [tokens.agent.editor.textTranslator.glossary.cancelButton]: 'Cancelar',
  [tokens.agent.editor.textTranslator.glossary.confirmDeleteButton]: 'Deletar',
  [tokens.agent.editor.textTranslator.glossary.viewTitle]: 'Visualizar glossário',
  [tokens.agent.editor.textTranslator.glossary.loadingGlossary]: 'Carregando...',
  [tokens.files.title]: 'Gerenciador de Arquivos',
  [tokens.files.subtitle]: 'Gerencie suas pastas e arquivos aqui.',
  [tokens.files.storage.title]: 'Armazenamento da Workstation',
  [tokens.files.storage.used]: '0.00 MB de 500 MB',
  [tokens.files.storage.locked]: '0%',
  [tokens.files.integration.title.googledrive]: 'Google Drive',
  [tokens.files.integration.title.onedrive]: 'OneDrive',
  [tokens.files.integration.title.sharepoint]: 'SharePoint',
  [tokens.files.myFolders]: 'Minhas pastas',
  [tokens.files.search.placeholder]: 'Buscar pastas...',
  [tokens.files.folderTable.name]: 'Nome',
  [tokens.files.folderTable.items]: 'Itens',
  [tokens.files.folderTable.size]: 'Tamanho',
  [tokens.files.folderTable.createdAt]: 'Criado em',
  [tokens.files.folderTable.type]: 'Tipo',
  [tokens.files.folderTable.private]: 'Privada',
  [tokens.files.folderTable.new]: 'Nova pasta',
  [tokens.files.folderTable.editFolder]: 'Editar pasta',
  [tokens.files.folderTable.deleteFolder]: 'Deletar pasta',
  [tokens.files.folderTable.access.allowedGroups]: 'Grupos permitidos',
  [tokens.files.folderTable.access.allowedUsers]: 'Usuários permitidos',
  [tokens.files.folderTable.access.selectMembers]: 'Selecionar membros',
  [tokens.files.folderTable.access.selectGroups]: 'Selecionar grupos',
  [tokens.files.folderTable.access.selectAllGroups]: 'Selecionar todos',
  [tokens.files.folderTable.access.selectAllMembers]: 'Selecionar todos',
  [tokens.files.folderTable.createFolder.folderName]: 'Nome da Pasta',
  [tokens.files.folderTable.createFolder.title]: 'Criar Pasta',
  [tokens.files.folderTable.noResults]: 'Nenhuma pasta encontrada.',
  [tokens.files.folderTable.searching]: 'Procurando pastas...',
  [tokens.files.fileTable.filter]: 'Filtrar arquivos...',
  [tokens.files.fileTable.name]: 'Nome do Arquivo',
  [tokens.files.fileTable.size]: 'Tamanho (Mb)',
  [tokens.files.fileTable.status]: 'Status',
  [tokens.files.fileTable.uploadedAt]: 'Enviado em',
  [tokens.files.fileTable.uploadCompleted]: 'Concluído',
  [tokens.files.fileTable.uploadFile]: 'Enviar arquivo',
  [tokens.files.fileTable.noResults]: 'Nenhum resultado, comece a enviar arquivos para a pasta selecionada',
  [tokens.integrations.title]: 'Integrações de Aplicativos',
  [tokens.integrations.description]: 'Aqui está uma lista de seus apps para integração!',
  [tokens.integrations.filter.placeholder]: 'Filtrar apps...',
  [tokens.integrations.filter.all]: 'Todos os apps',
  [tokens.integrations.filter.connected]: 'Conectado',
  [tokens.integrations.filter.notConnected]: 'Não conectado',
  [tokens.integrations.card.comingSoon]: 'Em breve',
  [tokens.integrations.card.googleDrive.title]: 'Google Drive',
  [tokens.integrations.card.googleDrive.description]: 'Conecte com o Google Drive para gerenciar seus arquivos.',
  [tokens.integrations.card.microsoft.title]: 'Microsoft',
  [tokens.integrations.card.microsoft.description]: 'Conecte com o OneDrive e SharePoint para gerenciar seus arquivos.',
  [tokens.integrations.card.whatsapp.title]: 'WhatsApp',
  [tokens.integrations.card.whatsapp.description]: 'Integre facilmente o WhatsApp para mensagens diretas.',
  [tokens.settings.title]: 'Configurações',
  [tokens.settings.subtitle]: 'Gerencie as configurações da sua conta e preferências.',
  [tokens.settings.usage.title]: 'Uso',
  [tokens.settings.usage.subtitle]: 'Veja suas estatísticas de uso.',
  [tokens.settings.usage.subtitleHistory]: 'Acompanhe seu consumo de recursos ao longo do tempo.',
  [tokens.settings.usage.questionsAsked]: 'Perguntas feitas',
  [tokens.settings.usage.processedPages]: 'Páginas processadas',
  [tokens.settings.usage.minutesUsed]: 'Minutos utilizados',
  [tokens.settings.usage.organizationMembers]: 'Membros da organização',
  [tokens.settings.usage.upgradePlan]: 'Atualizar plano',
  [tokens.settings.usage.usageLimitCredits]: 'Após atingir o limite de uso, os créditos serão utilizados.',
  [tokens.settings.usage.viewCredits]: 'Ver créditos',
  [tokens.settings.usage.maxMbUpload]: 'Limite de Upload (MB)',
  [tokens.settings.usage.filters.questions]: 'Perguntas',
  [tokens.settings.usage.filters.pages]: 'Páginas processadas',
  [tokens.settings.usage.filters.minutes]: 'Minutos utilizados',
  [tokens.settings.usage.filters.charges]: 'Recargas',
  [tokens.settings.usage.filters.agentExecutedNodes]: 'Nós executados por agentes',
  [tokens.settings.usage.filters.assistants]: 'Assistentes',
  [tokens.settings.usage.filters.mbDocs]: 'MB Documentos',
  [tokens.settings.usage.filters.mbSpreadsheets]: 'MB Planilhas',
  [tokens.settings.usage.filters.mbTranslator]: 'MB Tradutor (mês)',
  [tokens.settings.members.title]: 'Membros',
  [tokens.settings.members.subtitle]: 'Gerencie os membros da sua organização.',
  [tokens.settings.members.invite]: 'Convidar membros',
  [tokens.settings.members.noMembersFound]: 'Nenhum membro encontrado',
  [tokens.settings.members.noMembersSearchMatch]: 'Nenhum membro corresponde aos seus critérios de busca. Tente outro termo ou adicione um novo membro.',
  [tokens.settings.members.noMembersAddedMessage]: 'Você ainda não adicionou nenhum membro.',
  [tokens.settings.members.inviteDescription]: 'Convide novos membros para sua organização aqui. Clique em salvar quando terminar.',
  [tokens.settings.members.filter]: 'Filtrar membros...',
  [tokens.settings.members.fields.name]: 'Nome',
  [tokens.settings.members.validation.emailRequired]: 'E-mail é obrigatório',
  [tokens.settings.members.validation.nameRequired]: 'Nome é obrigatório',
  [tokens.settings.members.you]: 'Você',
  [tokens.settings.groups.title]: 'Grupos',
  [tokens.settings.groups.subtitle]: 'Gerencie grupos de usuários e suas permissões.',
  [tokens.settings.groups.createGroup]: 'Criar grupo',
  [tokens.settings.groups.filterGroup]: 'Filtrar grupos...',
  [tokens.settings.groups.name]: 'Nome do grupo',
  [tokens.settings.groups.membersLabel]: 'Membro',
  [tokens.settings.groups.membersLabel_other]: 'Membros',
  [tokens.settings.groups.permissionsLabel]: 'Permissão',
  [tokens.settings.groups.permissionsLabel_other]: 'Permissões',
  [tokens.settings.groups.selectPermissions]: 'Selecionar permissões',
  [tokens.settings.groups.delete.confirmation]: 'Você tem certeza de que deseja deletar este grupo? Esta ação não poderá ser desfeita.',
  [tokens.settings.groups.delete.warning]: 'Deletar este grupo removerá todas as permissões associadas aos usuários neste grupo.',
  [tokens.settings.groups.delete.title]: 'Deletar grupo "{{currentGroup}}"',
  [tokens.settings.groups.add.title]: 'Adicionar novo grupo',
  [tokens.settings.groups.add.description]: 'Crie um novo grupo aqui. Clique em salvar quando terminar.',
  [tokens.settings.groups.noGroupsFound]: 'Nenhum grupo encontrado',
  [tokens.settings.groups.noGroupsSearchMatch]: 'Nenhum grupo corresponde aos seus critérios de busca. Tente outro termo ou crie um novo grupo.',
  [tokens.settings.groups.noGroupsAddedMessage]: 'Você ainda não criou nenhum grupo. Grupos ajudam a organizar usuários e gerenciar permissões.',
  [tokens.settings.appearance.preferences.title]: 'Preferências',
  [tokens.settings.appearance.preferences.subtitle]: 'Personalize as preferências da sua plataforma',
  [tokens.settings.appearance.logo.title]: 'Logo da organização',
  [tokens.settings.appearance.logo.subtitle]: 'Personalize sua organização alterando o logo.',
  [tokens.settings.appearance.logo.maxSize]: 'Tamanho recomendado',
  [tokens.settings.appearance.organization.name.title]: 'Nome da organização',
  [tokens.settings.appearance.organization.name.subtitle]: 'Altere o nome da sua organização.',
  [tokens.settings.appearance.font]: 'Fonte',
  [tokens.settings.appearance.fontDescription]: 'Escolha a fonte que deseja usar no painel.',
  [tokens.settings.appearance.theme.title]: 'Tema',
  [tokens.settings.appearance.themeDescription]: 'Escolha o tema para o painel.',
  [tokens.settings.appearance.theme.light]: 'Claro',
  [tokens.settings.appearance.theme.dark]: 'Escuro',
  [tokens.settings.appearance.save]: 'Salvar preferências',
  [tokens.settings.billing.title]: 'Faturamento',
  [tokens.settings.billing.subtitle]: 'Gerencie suas informações de faturamento.',
  [tokens.settings.billing.subtitleHistory]: 'Acompanhe seu histórico de faturamento ao longo do tempo.',
  [tokens.settings.billing.creditBalance]: 'Saldo de crédito',
  [tokens.settings.billing.addCredit]: 'Adicionar saldo de crédito',
  [tokens.settings.billing.managePlan]: 'Gerenciar plano',
  [tokens.settings.billing.plan_attention.title]: 'Plano requer atenção',
  [tokens.settings.billing.plan_attention.description]: 'Seu plano precisa ser renovado ou créditos adicionais adicionados para continuar usando este recurso.',
  [tokens.settings.billing.plan_attention.cta]: 'Ver meu plano',
  [tokens.settings.billing.autoRecharge]: 'Recarga automática',
  [tokens.settings.billing.autoRechargeDescription]: 'Quando seu saldo atingir ${{triggerAmount}}, sua forma de pagamento será cobrada para trazer o saldo até ${{rechargeAmount}}. Valor máximo de ${{monthlyLimit}}.',
  [tokens.settings.billing.modify]: 'Modificar',
  [tokens.settings.billing.ensureDefaultPaymentMethod]: 'Certifique-se de que um método de pagamento padrão esteja configurado.',
  [tokens.settings.billing.availableCreditsTooltip]: 'Este é o valor de créditos que você tem disponível. Os créditos serão consumidos apenas quando um item em sua cota atingir o limite máximo.',
  [tokens.settings.billing.credits.add]: 'Adicionar créditos',
  [tokens.settings.billing.credits.total_amount]: 'Valor total',
  [tokens.settings.billing.credits.common_options]: 'Opções comuns',
  [tokens.settings.billing.credits.add_specific]: 'Adicionar ${{creditAmount}} créditos',
  [tokens.settings.billing.credits.monthly_limit]: 'Limite mensal',
  [tokens.settings.billing.credits.monthly_limit_tooltip]: 'O número máximo de recargas automáticas permitidas por mês. Essa medida de segurança garante que sua conta não exceda um orçamento pré-determinado, proporcionando controle financeiro e previsibilidade.',
  [tokens.settings.billing.credits.auto_recharge_settings]: 'Configurações de recarga automática',
  [tokens.settings.billing.credits.trigger_amount]: 'Valor de disparo',
  [tokens.settings.billing.credits.trigger_amount_tooltip]: 'O limite que inicia uma recarga automática. Quando seu saldo de créditos cair abaixo desse valor, o sistema recarregará automaticamente sua conta.',
  [tokens.settings.billing.credits.target_amount]: 'Valor alvo',
  [tokens.settings.billing.credits.target_amount_tooltip]: 'O saldo de créditos a ser atingido após uma recarga automática. O sistema adicionará fundos suficientes para alcançar esse valor quando a recarga for disparada.',
  [tokens.settings.billing.credits.save_changes]: 'Salvar alterações',
  [tokens.settings.billing.history.paid]: 'Pago',
  [tokens.settings.billing.history.pending]: 'Pendente',
  [tokens.settings.billing.view.receipt]: 'Ver recibo',
  [tokens.settings.apiKey.title]: 'Chaves de API',
  [tokens.settings.apiKey.subtitle]: 'Gere e gerencie suas chaves aqui.',
  [tokens.settings.apiKey.createButton]: 'Criar chave de API',
  [tokens.settings.apiKey.searchMessage]: 'Buscando...',
  [tokens.settings.apiKey.noTokensFoundMessage]: 'Nenhum token encontrado.',
  [tokens.settings.apiKey.createToastSuccess]: 'Token criado com sucesso.',
  [tokens.settings.apiKey.createDialogSubtitle]: 'Crie uma nova chave de API aqui. Clique em salvar quando terminar.',
  [tokens.settings.apiKey.baseDialog.expiresAt]: 'Data de expiração',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.fifteenDays]: '15 dias',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.thirtyDays]: '30 dias',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.never]: 'Nunca',
  [tokens.settings.apiKey.baseDialog.system]: 'Sistema',
  [tokens.settings.apiKey.baseDialog.systemTokenTooltip]: 'Tokens de sistema são usados para autenticar requisições à API. Eles não estão vinculados a um usuário específico, então você deve atribuir manualmente as permissões necessárias. Quando a opção "sistema" está desativada, o token é vinculado a um usuário e segue as permissões atribuídas a ele.',
  [tokens.settings.apiKey.copyNewTokenDialog.title]: 'Copie seu token',
  [tokens.settings.apiKey.copyNewTokenDialog.description]: 'Copie seu token agora. Ele não será exibido novamente. Armazene-o em um local seguro.',
  [tokens.settings.apiKey.tableColumns.name]: 'Nome',
  [tokens.settings.apiKey.tableColumns.apiKey]: 'Chave de api',
  [tokens.settings.apiKey.tableColumns.createdAt]: 'Criado em',
  [tokens.settings.apiKey.tableColumns.permissions]: 'Permissões',
  [tokens.settings.apiKey.tableColumns.noPermissionsTooltip]: 'Sem permissões',
  [tokens.settings.apiKey.tableColumns.activeStatusChip]: 'Ativo',
  [tokens.settings.apiKey.tableColumns.expiredStatusChip]: 'Expirado',
  [tokens.settings.apiKey.deleteToastSuccess]: 'Token deletado com sucesso.',
  [tokens.settings.apiKey.baseDialog.name]: 'Nome',
  [tokens.settings.apiKey.baseDialog.namePlaceholder]: 'Ex: Meu Token',
  [tokens.settings.apiKey.baseDialog.selectExpirationDate]: 'Selecione a data de expiração do token',
  [tokens.settings.apiKey.baseDialog.associatedGroups]: 'Grupos Associados',
  [tokens.settings.apiKey.baseDialog.associatedGroupsTooltip]: 'Associe grupos para que o token herde automaticamente suas permissões e tenha acesso às pastas dos grupos selecionados, complementando as permissões individuais definidas acima.',
  [tokens.settings.apiKey.baseDialog.selectGroups]: 'Selecionar grupos',
  [tokens.settings.apiKey.baseDialog.allowedFolders]: 'Pastas Permitidas',
  [tokens.sidebar.section.general]: 'Geral',
  [tokens.sidebar.section.other]: 'Outros',
  [tokens.sidebar.dashboard]: 'Dashboard',
  [tokens.sidebar.workstation]: 'Estação de trabalho',
  [tokens.sidebar.files.title]: 'Arquivos',
  [tokens.sidebar.files.search]: 'Buscar',
  [tokens.sidebar.files.myFolders]: 'Minhas pastas',
  [tokens.sidebar.integrations]: 'Integrações',
  [tokens.sidebar.settings]: 'Configurações',
  [tokens.sidebar.members]: 'Membros',
  [tokens.sidebar.groups]: 'Grupos',
  [tokens.sidebar.appearance]: 'Aparência',
  [tokens.sidebar.billing]: 'Faturamento',
  [tokens.sidebar.usage]: 'Uso',
  [tokens.sidebar.helpcenter]: 'Ajuda',
  [tokens.sidebar.statusPage]: 'Página de status',
  [tokens.sidebar.documentation]: 'Documentação',
  [tokens.ui.textEditor.toolbar.undo]: 'Desfazer',
  [tokens.ui.textEditor.toolbar.redo]: 'Refazer',
  [tokens.ui.textEditor.toolbar.fullscreen]: 'Tela cheia',
  [tokens.ui.textEditor.toolbar.exitFullscreen]: 'Sair da tela cheia',
  [tokens.ui.textEditor.stats.characters]: 'Caracteres',
  [tokens.ui.textEditor.stats.minimum]: 'Mínimo',
  [tokens.ui.textEditor.readOnly]: 'Somente leitura',
  [tokens.ui.selectlanguage]: 'Selecionar idioma',
  [tokens.ui.common.searchInput]: 'Buscar',
  [tokens.ui.common.pagination.pageOf]: 'Página {{current}} de {{total}}',
  [tokens.ui.common.datetime.days]: '{{count}} dia',
  [tokens.ui.common.datetime.days_other]: '{{count}} dias',
  [tokens.ui.common.comingSoon]: 'Em breve',
  [tokens.ui.common.selectDatePeriod]: 'Selecione o período de data',
  [tokens.ui.common.calendar]: 'Calendário',
  [tokens.ui.common.periods]: 'Períodos',
  [tokens.ui.common.apply]: 'Aplicar',
  [tokens.ui.common.warning]: 'Aviso',
  [tokens.ui.common.removeMemberWarning]: 'Ao remover este membro, todas as permissões associadas a ele serão removidas.',
  [tokens.ui.common.removeMember]: 'Remover membro',
  [tokens.ui.common.noResultsFound]: 'Nenhum resultado encontrado.',
  [tokens.ui.common.noOptionsFound]: 'Nenhuma opção encontrada.',
  [tokens.ui.common.search]: 'Buscar...',
  [tokens.ui.common.page]: 'Página',
  [tokens.ui.common.history]: 'Histórico',
  [tokens.ui.common.consumption]: 'Consumo',
  [tokens.ui.common.date]: 'Data',
  [tokens.ui.common.quantity]: 'Quantidade',
  [tokens.ui.common.noRecordsFound]: 'Nenhum registro encontrado.',
  [tokens.ui.feature.underDevelopment]: 'Este recurso está em desenvolvimento e estará disponível em breve.',
  [tokens.ui.date.predefinedPeriods]: 'Períodos predefinidos',
  [tokens.ui.date.today]: 'Hoje',
  [tokens.ui.date.yesterday]: 'Ontem',
  [tokens.ui.date.last7Days]: 'Últimos 7 dias',
  [tokens.ui.date.last30Days]: 'Últimos 30 dias',
  [tokens.ui.date.currentMonth]: 'Mês atual',
  [tokens.ui.date.lastMonth]: 'Mês passado',
  [tokens.ui.date.currentYear]: 'Ano atual',
  [tokens.ui.auth.logout]: 'Sair',
  [tokens.ui.input.placeholder.command]: 'Digite um comando ou pesquise...',
  [tokens.ui.theme.light]: 'Claro',
  [tokens.ui.theme.dark]: 'Escuro',
  [tokens.ui.theme.system]: 'Sistema',
  [tokens.ui.confirmation.DoYouConfirmThisAction]: 'Você confirma esta ação?',
  [tokens.ui.confirmation.areYouSure]: 'Tem certeza?',
  [tokens.ui.confirmation.cannotBeUndone]: 'Essa ação não pode ser desfeita. Você confirma a exclusão?',
  [tokens.ui.confirmation.nodeDeleteWarning]: 'A exclusão deste nó apagará os dados permanentemente. Esta ação é definitiva. Deseja continuar?',
  [tokens.ui.actions.start]: 'Iniciar',
  [tokens.ui.actions.stop]: 'Parar',
  [tokens.ui.actions.back]: 'Voltar',
  [tokens.ui.actions.create]: 'Criar',
  [tokens.ui.actions.cancel]: 'Cancelar',
  [tokens.ui.actions.delete]: 'Deletar',
  [tokens.ui.actions.deleteAll]: 'Deletar tudo',
  [tokens.ui.actions.update]: 'Atualizar',
  [tokens.ui.actions.continue]: 'Continuar',
  [tokens.ui.actions.save]: 'Salvar',
  [tokens.ui.actions.saving]: 'salvando...',
  [tokens.ui.actions.ask]: 'Perguntar',
  [tokens.ui.table.rowsSelected]: '{{count}} de {{total}} linha(s) selecionada(s).',
  [tokens.ui.common.sort.asc]: 'Crescente',
  [tokens.ui.common.sort.desc]: 'Decrescente',
  [tokens.ui.common.loading]: 'Carregando...',
  [tokens.ui.common.enabled]: 'ativada',
  [tokens.ui.common.disabled]: 'desativada',
  [tokens.ui.common.of]: 'de',
  [tokens.ui.common.delete]: 'Deletar',
  [tokens.ui.common.view]: 'Visualizar',
  [tokens.ui.common.edit]: 'Editar',
  [tokens.ui.common.selectConversation]: 'Selecione uma conversa',
  [tokens.ui.page.notCreated]: 'Ainda não criamos esta página.',
  [tokens.ui.page.stayTuned]: 'Fique ligado!',
  [tokens.ui.toasts.organization.switch_success]: 'Organização alterada com sucesso!',
  [tokens.ui.toasts.team.delete_active_error]: 'Não é possível deletar o time ativo',
  [tokens.ui.toasts.form.submit_values]: 'Você enviou os seguintes valores:',
  [tokens.ui.toasts.auth.sign_in_now]: 'Agora você pode fazer login.',
  [tokens.ui.toasts.user.deleted]: 'O seguinte usuário foi deletado:',
  [tokens.ui.toasts.file.upload_success]: 'Arquivo enviado',
  [tokens.ui.toasts.file.uploaded_successfully]: 'Seu arquivo foi enviado com sucesso.',
  [tokens.ui.toasts.folder.create_success]: 'A pasta foi criada com sucesso',
  [tokens.ui.toasts.folder.created.description]: 'A pasta foi criada com sucesso',
  [tokens.ui.toasts.file.delete_success]: 'Arquivos deletados com sucesso',
  [tokens.ui.toasts.template.delete_success]: 'Templates deletados com sucesso',
  [tokens.ui.toasts.folder.delete_success]: 'Pastas deletadas com sucesso',
  [tokens.ui.toasts.organization.invite_failed]: 'Erro ao aceitar o convite',
  [tokens.ui.toasts.organization.invite_accepted.title]: 'Convite para organização aceito',
  [tokens.ui.toasts.organization.invite_accepted.description]: 'Você agora é membro da organização {{organizationName}}',
  [tokens.ui.toasts.organization.create_success]: 'Organização criada com sucesso!',
  [tokens.ui.toasts.organization.create_error]: 'Erro ao criar organização',
  [tokens.ui.toasts.organization.delete_failed]: 'Falha ao deletar a organização',
  [tokens.ui.toasts.subscription.failed]: 'Não foi possível realizar a assinatura. Tente novamente mais tarde.',
  [tokens.ui.toasts.sales.contact]: 'Nossa equipe de vendas entrará em contato em breve!',
  [tokens.ui.toasts.autorecharge.enabled]: 'Recarga automática ativada',
  [tokens.ui.toasts.autorecharge.disabled]: 'Recarga automática desativada',
  [tokens.ui.toasts.autorecharge.status]: 'Recarga automática foi ${checked ? \'ativada\' : \'desativada\'}',
  [tokens.ui.toasts.error.title]: 'Erro',
  [tokens.ui.toasts.error.forbidden]: 'Você não tem permissão para realizar esta ação.',
  [tokens.ui.moduleAccessDenied.title]: 'Funcionalidade Indisponível',
  [tokens.ui.moduleAccessDenied.description]:
    'Sua organização não tem mais acesso a esta funcionalidade. Entre em contato com o administrador da organização para mais informações.',
  [tokens.ui.moduleAccessDenied.cta]: 'Entendi',
  [tokens.ui.toasts.payment.default_method_error]: 'Defina um método de pagamento padrão.',
  [tokens.ui.toasts.autorecharge.update_failed]: 'Falha ao atualizar recarga automática',
  [tokens.ui.toasts.autorecharge.update_success.title]: 'Configurações de recarga automática atualizadas',
  [tokens.ui.toasts.autorecharge.update_success.description]: 'Suas configurações de recarga automática foram atualizadas com sucesso.',
  [tokens.ui.toasts.autorecharge.update_settings_failed]: 'Erro ao atualizar configurações de recarga automática',
  [tokens.ui.toasts.autorecharge.status]: 'Recarga automática foi {{status}}',
  [tokens.ui.toasts.amount.invalid]: 'Valor inválido',
  [tokens.ui.toasts.amount.enter_valid]: 'Insira um valor válido maior que 0',
  [tokens.ui.toasts.credit.purchase_failed]: 'Falha ao processar compra de créditos',
  [tokens.ui.toasts.group.create_success]: 'Grupo criado com sucesso!',
  [tokens.ui.toasts.group.update_success]: 'Grupo atualizado com sucesso!',
  [tokens.ui.toasts.group.delete_success]: 'Grupo deletado com sucesso!',
  [tokens.ui.toasts.group.create_error.title]: 'Erro ao criar grupo',
  [tokens.ui.toasts.group.create_error.description]: 'Ocorreu um erro ao criar o grupo. Por favor, tente novamente.',
  [tokens.ui.toasts.group.update_error.title]: 'Erro ao atualizar grupo',
  [tokens.ui.toasts.group.update_error.description]: 'Ocorreu um erro ao atualizar o grupo. Por favor, tente novamente.',
  [tokens.ui.toasts.group.delete_error.title]: 'Erro ao deletar grupo',
  [tokens.ui.toasts.group.delete_error.description]: 'Ocorreu um erro ao deletar o grupo. Por favor, tente novamente.',
  [tokens.ui.toasts.member.invite_success]: 'Membro convidado com sucesso!',
  [tokens.ui.toasts.member.removed_success]: 'Membro removido com sucesso!',
  [tokens.ui.toasts.member.invite_error.title]: 'Erro ao convidar membro',
  [tokens.ui.toasts.member.invite_error.description]: 'Ocorreu um erro ao convidar o membro. Por favor, tente novamente.',
  [tokens.ui.toasts.member.remove_error.title]: 'Erro ao remover membro',
  [tokens.ui.toasts.member.remove_error.description]: 'Ocorreu um erro ao remover o membro. Por favor, tente novamente.',
  [tokens.ui.toasts.request.review]: 'Nós vamos revisar sua solicitação e entraremos em contato em breve.',
  [tokens.ui.toasts.request.failed]: 'Falha ao enviar a solicitação',
  [tokens.ui.toasts.task.deleted]: 'A seguinte tarefa foi deletada:',
  [tokens.ui.toasts.file.imported]: 'Você importou o seguinte arquivo:',
  [tokens.ui.toasts.error.generic]: 'Um erro inesperado ocorreu, por favor aguarde alguns instantes e tente novamente!',
  [tokens.ui.toasts.account.created_successfully.title]: 'Conta criada com sucesso',
  [tokens.ui.toasts.account.created_successfully.description]: 'Agora você já pode fazer login',
  [tokens.ui.toasts.common.try_again_later]: 'Por favor, tente novamente mais tarde',
  [tokens.ui.toasts.request.received]: 'Solicitação recebida',
  [tokens.ui.toasts.request.send_success.title]: 'Solicitação enviada com sucesso',
  [tokens.ui.toasts.auth.login_error.title]: 'Erro ao fazer login',
  [tokens.ui.toasts.folder.delete_error.title]: 'Erro ao deletar pasta',
  [tokens.ui.toasts.folder.delete_error.description]: 'Ocorreu um erro ao deletar a pasta. Por favor, tente novamente.',
  [tokens.ui.toasts.folder.create_error.title]: 'Erro ao criar pasta',
  [tokens.ui.toasts.folder.create_error.description]: 'Ocorreu um erro ao criar a pasta. Por favor, tente novamente.',
  [tokens.ui.toasts.folder.update_error.title]: 'Erro ao atualizar pasta',
  [tokens.ui.toasts.folder.update_error.description]: 'Ocorreu um erro ao atualizar a pasta. Por favor, tente novamente.',
  [tokens.ui.toasts.folder.delete_error_plural.title]: 'Erro ao deletar pastas',
  [tokens.ui.toasts.folder.delete_error_plural.description]: 'Ocorreu um erro ao deletar as pastas. Por favor, tente novamente.',
  [tokens.ui.toasts.file.delete_error.title]: 'Erro ao deletar arquivos',
  [tokens.ui.toasts.file.delete_error.description]: 'Ocorreu um erro ao deletar os arquivos. Por favor, tente novamente.',
  [tokens.ui.toasts.generic_error.title]: 'Ocorreu um erro',
  [tokens.ui.toasts.generic_error.default_message]: 'Ocorreu um erro ao realizar a operação. Por favor, tente novamente.',
  [tokens.ui.auth.login.subtitle]: 'Digite seu e-mail e senha abaixo',
  [tokens.ui.auth.login.description]: 'para acessar sua conta',
  [tokens.ui.auth.login.agreement.prefix]: 'Ao clicar em entrar, você concorda com nossos',
  [tokens.ui.auth.login.agreement.terms]: 'Termos de Serviço',
  [tokens.ui.auth.login.agreement.privacy]: 'Política de Privacidade',
  [tokens.ui.auth.login.agreement.and]: 'e',
  [tokens.ui.auth.login.forgot]: 'Esqueceu a senha?',
  [tokens.ui.auth.login.password]: 'Senha',
  [tokens.ui.auth.login.no_account]: 'Não tem uma conta?',
  [tokens.ui.auth.login.signup]: 'Criar conta',
  [tokens.ui.auth.login.or_continue]: 'Ou continue com',
  [tokens.ui.auth.signup.title]: 'Crie uma conta',
  [tokens.ui.auth.signup.confirmPassword]: 'Confirmar senha',
  [tokens.ui.auth.signup.subtitle]: 'Digite seu e-mail e senha para criar uma conta.',
  [tokens.ui.auth.signup.already]: 'Já tem uma conta?',
  [tokens.ui.auth.signup.signin]: 'Entrar',
  [tokens.ui.auth.forgot.title]: 'Esqueceu a senha',
  [tokens.ui.auth.forgot.email]: 'E-mail',
  [tokens.ui.auth.forgot.enter_registered_email]: 'Insira seu e-mail cadastrado',
  [tokens.ui.auth.forgot.send_password_link]: 'e enviaremos um link para redefinir sua senha.',
  [tokens.ui.auth.forgot.submit]: 'Enviar link de redefinição de senha',
  [tokens.ui.auth.forgot.signup]: 'Não tem uma conta?',
  [tokens.ui.auth.forgot.signup_link]: 'Criar conta',
  [tokens.ui.folderMultiSelect.selectAll]: 'Selecionar todas',
  [tokens.ui.folderMultiSelect.unselectAll]: 'Desmarcar todas',
  [tokens.ui.folderMultiSelect.defaultPlaceholder]: 'Selecionar pastas',
  [tokens.plans.community]: 'Comunidade',
  [tokens.plans.commercial]: 'Comercial',
  [tokens.plans.enterprise]: 'Empresarial',
  [tokens.landing.knowledge_management]: 'Gestão do conhecimento',
  [tokens.landing.optimize_knowledge]: 'Otimize a gestão do conhecimento',
  [tokens.landing.knowledge_management_description]: 'A gestão eficaz do conhecimento é fundamental para aumentar a produtividade, melhorar a colaboração e acelerar a inovação dentro de uma organização.',
  [tokens.landing.work_ai_agent]: 'Work AI Agent',
  [tokens.landing.custom_solutions]: 'Soluções Personalizadas',
  [tokens.landing.custom_solutions_description]: 'Nossas soluções personalizadas são projetadas para atender às necessidades únicas de sua empresa, garantindo que cada implementação seja otimizada para o seu sucesso.',
  [tokens.landing.integrations_description]: 'Nossa plataforma de IA foi projetada para oferecer integrações perfeitas com as principais ferramentas do mercado. Com isso, você pode conectar seus sistemas e otimizar processos sem complicações. Garantimos compatibilidade com uma ampla gama de soluções para atender às suas necessidades específicas.',
  [tokens.landing.smart_agents_description]: 'Desenvolva agentes interativos que oferecem respostas rápidas e precisas, melhorando a experiência e automatizando processos.',
  [tokens.landing.resources]: 'Recursos',
  [tokens.landing.blog]: 'Blog',
  [tokens.landing.login]: 'Log In',
  [tokens.landing.get_demo]: 'Começar',
  [tokens.landing.description]: 'Encontre qualquer informação da sua empresa em segundos — mesmo que esteja em PDFs, planilhas, vídeos ou imagens. O Alan interpreta, organiza tudo, permite buscas rápidas e automatiza tarefas. Sem código. Sem complicação.',
  [tokens.landing.start_now]: 'Começar agora',
  [tokens.landing.automotive_chip]: 'Automotivo',
  [tokens.landing.automotive_title]: 'Solução de IA aplicada ao ciclo de vida de produtos automotivos',
  [tokens.landing.machinery_equipment_chip]: 'Máquinas e equipamentos',
  [tokens.landing.machinery_equipment_title]: 'Solução de IA para Análise do Ciclo de Vida de Produtos e Maquinário',
  [tokens.landing.media_communication_chip]: 'Mídia e comunicação',
  [tokens.landing.media_communication_title]: 'Inteligência Artificial para Análise Econômica',
  [tokens.landing.aviation_chip]: 'Aviação',
  [tokens.landing.aviation_title]: 'Solução para recuperação de conhecimento técnico em ambientes complexos de manutenção e suporte',
  [tokens.landing.get_in_touch]: 'Entre em contato',
  [tokens.landing.ai_leader]: 'Líder em pesquisa e desenvolvimento de inteligência artificial, oferecendo soluções pré-desenvolvidas e customizadas para todas as indústrias.',
  [tokens.landing.ai_solutions_and_research]: 'Soluções de IA e pesquisa',
  [tokens.landing.transformation_examples]: 'Exemplos de transformação com nossos clientes:',
  [tokens.landing.tool_integrations]: 'Integrações com ferramentas',
  [tokens.landing.realtime_metrics_chip]: 'Métricas em Tempo Real',
  [tokens.landing.realtime_metrics_title]: 'Monitore dados e desempenho instantaneamente',
  [tokens.landing.smart_agents]: 'Agentes inteligentes e interativos',
  [tokens.landing.tailored_solutions]: 'Soluções sob medida para seu negócio',
  [tokens.landing.integrations_with_your_tools]: 'Integrações com as suas Ferramentas',
  [tokens.landing.who_trust_us]: 'Quem confia em nós',
  [tokens.landing.who_already_uses]: 'Que já usa',
  [tokens.landing.simplify_ai]: 'Simplifique a implementação de IA',
  [tokens.landing.in_enterprise]: 'no mundo empresarial',
  [tokens.landing.full_platform]: 'Plataforma completa para integrar, desenvolver e gerenciar soluções de IA com segurança e escalabilidade',
  [tokens.landing.prompt_library]: 'Biblioteca de Prompts',
  [tokens.landing.reuse_prompts]: 'Reutilize e compartilhe prompts eficazes',
  [tokens.landing.smart_search]: 'Pesquisa Inteligente',
  [tokens.landing.find_info_ai]: 'Encontre qualquer informação em segundos com busca potencializada por IA',
  [tokens.landing.business_chat]: 'Chat Empresarial',
  [tokens.landing.natural_chat_interface]: 'Interaja com seus dados através de uma interface conversacional natural',
  [tokens.landing.autonomous_agents]: 'Agentes Autônomos',
  [tokens.landing.create_no_code_agents]: 'Crie assistentes de IA sem código que automatizam tarefas complexas',
  [tokens.landing.enterprise_ai_platform]: 'Plataforma de IA Empresarial',
  [tokens.landing.full_architecture]: 'Arquitetura completa para implementação segura e escalável',
  [tokens.landing.genai_foundation]: 'Fundação GenAI',
  [tokens.landing.multi_llm]: 'Multi-LLM',
  [tokens.landing.multi_llm_access]: 'Acesso a múltiplos modelos de linguagem',
  [tokens.landing.rag_engine]: 'RAG',
  [tokens.landing.rag_description]: 'Pergunte para um volume ilimitado de informação e receba respostas dinâmicas e confiáveis',
  [tokens.landing.memory]: 'Memória',
  [tokens.landing.dynamic_learning]: 'Aprendizado dinâmico e automático conforme interage',
  [tokens.landing.intelligence_layer]: 'Camada de Inteligência',
  [tokens.landing.knowledge_graph]: 'Grafo de Conhecimento',
  [tokens.landing.knowledge_mapping]: 'Mapeamento de relações entre dados',
  [tokens.landing.hybrid_search]: 'Pesquisa Híbrida',
  [tokens.landing.hybrid_search_description]: 'Combinação de busca vetorial e semântica',
  [tokens.landing.self_learning]: 'Autoaprendizado',
  [tokens.landing.self_learning_description]: 'Modelos que melhoram com o uso',
  [tokens.landing.security_governance]: 'Segurança & Governança',
  [tokens.landing.real_time_permissions]: 'Permissões em Tempo Real',
  [tokens.landing.access_control]: 'Controle granular de acesso',
  [tokens.landing.content_policies]: 'Políticas de Conteúdo',
  [tokens.landing.content_filtering]: 'Filtragem e moderação automática',
  [tokens.landing.continuous_audit]: 'Auditoria Contínua',
  [tokens.landing.audit_monitoring]: 'Monitoramento de uso e conformidade',
  [tokens.landing.full_ecosystem]: 'Ecossistema Completo',
  [tokens.landing.connect_tools]: 'Conecte-se com suas ferramentas e infraestrutura existentes',
  [tokens.landing.data_sources]: 'Suas fontes de dados',
  [tokens.landing.connect_all_tools]: 'Conecte-se a todas as suas ferramentas',
  [tokens.landing.engineering]: 'Engenharia',
  [tokens.landing.collaboration]: 'Colaboração',
  [tokens.landing.documents]: 'Documentos',
  [tokens.landing.businesses]: 'Negócios',
  [tokens.landing.infrastructure]: 'Sua infraestrutura',
  [tokens.landing.start_ai_today]: 'Comece sua jornada de IA hoje',
  [tokens.landing.transform_with_ai]: 'Transforme sua empresa com soluções de IA seguras, escaláveis e fáceis de implementar',
  [tokens.landing.security_and_governance]: 'Segurança e Governança',
  [tokens.landing.how_we_protect_data]: 'Como protegemos seus dados?',
  [tokens.landing.data_protection]: 'Utilizamos criptografia avançada e padrões de segurança internacionais para garantir que seus dados estejam sempre protegidos.',
  [tokens.landing.compliance_check]: 'Estamos em conformidade com normas de segurança?',
  [tokens.landing.compliance_answer]: 'Sim, seguimos as melhores práticas de mercado e estamos em conformidade com GDPR, LGPD e outras normas globais.',
  [tokens.landing.data_access]: 'Quem tem acesso às suas informações?',
  [tokens.landing.data_access_answer]: 'Apenas usuários autorizados e sistemas devidamente autenticados podem acessar suas informações, com registros de auditoria detalhados.',
  [tokens.landing.hero_title]: 'Alan – sua IA para um trabalho ágil',
  [tokens.landing.hero_subtitle]: 'Impulsione a produtividade do seu time com uma intranet inteligente.',
  [tokens.landing.contact_us_cta]: 'Entre em contato',
  [tokens.landing.contact_us_text]: 'Estamos aqui para ajudar com suas necessidades de IA',
  [tokens.landing.find_us]: 'Nos encontre',
  [tokens.landing.copyright]: '2025 Mr. Turing AI - Todos os direitos reservados',
  [tokens.landing.terms]: 'Termos e Condições',
  [tokens.landing.privacy]: 'Política de Privacidade',
  [tokens.landing.enterprise_cta]: 'Precisa de um plano para a sua empresa? Conheça o Enterprise. Fale conosco!',
  [tokens.landing.contact_button]: 'Nos contate',
  [tokens.landing.community_text]: 'Uma rede exclusiva focada em suporte e colaboração.',
  [tokens.landing.community_title]: 'Alan Community Network',
  [tokens.landing.slack_community_description]: 'Junte-se à nossa comunidade no Slack: tire dúvidas, compartilhe sugestões e colabore em um ambiente de aprendizado e troca.',
  [tokens.landing.support_title]: 'Suporte',
  [tokens.landing.support_description]: 'Nosso sistema de suporte está sempre pronto para ajudá-lo a resolver qualquer problema de forma rápida e eficiente.',
  [tokens.landing.get_started_cta]: 'Pronto para começar?',
  [tokens.landing.explore_prompts]: 'Explore os prompts da sua organização...',
  [tokens.landing.documentation_title]: 'Documentações',
  [tokens.landing.documentation_description]: 'Saiba mais sobre a documentação do Alan',
  [tokens.landing.community_title]: 'Comunidade',
  [tokens.landing.community_description]: 'Participe da comunidade do Alan',
  [tokens.landing.latest_posts_title]: 'Últimos Posts',
  [tokens.landing.latest_posts_description]: 'Confira os posts mais recentes do blog',
  [tokens.landing.recent_updates_title]: 'Atualizações Recentes',
  [tokens.landing.recent_updates_description]: 'Veja as últimas novidades e atualizações',
  [tokens.landing.schedule_demo]: 'Agendar demonstração',
  [tokens.landing.security_note]: 'Nossa segurança de nível empresarial mantém seus dados protegidos o tempo todo',
  [tokens.landing.automotive_description]: 'Uma aplicação de IA voltada à análise do ciclo de vida de produtos automotivos, integrando NLP, LLMs, visão computacional, mineração de dados e computação em nuvem. A solução gera insights estratégicos e orientados por dados. Ela identifica o momento ideal e o investimento mínimo necessário para manter a competitividade com base em uma análise precisa da concorrência.',
  [tokens.landing.machinery_equipment_description]: 'Criamos uma solução de IA para analisar o ciclo de vida de produtos e maquinários da CNH Industrial, usando NLP, LLMs, visão computacional e mineração de dados. Ela oferece insights sobre o momento ideal e o investimento necessário para manter a competitividade. A tecnologia evoluiu para funcionar offline, levando inovação ao público rural e regiões remotas.',
  [tokens.landing.media_communication_description]: 'A ConfIA é uma solução de IA que fornece respostas confiáveis e contextualizadas sobre economia e indicadores regionais. Capaz de interpretar textos e gráficos, ela garante informações acessíveis e precisas aos usuários. O projeto representa um avanço na disseminação de dados econômicos, alinhado à nossa missão de democratizar o acesso à informação.',
  [tokens.landing.realtime_metrics_description]: 'Com o Alan, você monitora o engajamento dos colaboradores e incentiva o uso estratégico da IA. Acompanhe rankings, métricas e interações para oferecer feedback contínuo e promover um ambiente colaborativo, produtivo e alinhado aos objetivos da empresa.',
  [tokens.landing.advanced_semantic_search]: 'Busca semântica avançada',
  [tokens.landing.contextual_answers]: 'Respostas contextualizadas',
  [tokens.landing.intelligent_automation]: 'Automação inteligente',
  [tokens.landing.login]: 'Entrar',
  [tokens.landing.send]: 'Enviar',
  [tokens.landing.flexible_ready]: 'Flexível e pronto para qualquer ambiente',
  [tokens.landing.form_response_success]: 'Mensagem enviada',
  [tokens.landing.form_response_title]: 'Formulário enviado',
  [tokens.landing.name_required]: 'Nome é obrigatório',
  [tokens.landing.email_required]: 'Email é obrigatório',
  [tokens.landing.invalid_email]: 'Formato de email inválido',
  [tokens.landing.required_field]: '*Obrigatório',
  [tokens.landing.form_response_error]: 'Falha ao enviar mensagem',
  [tokens.landing.api_documentation]: 'Documentação API',
  [tokens.landing.join_slack]: 'Entrar no Slack',
  [tokens.landing.platform]: 'Plataforma',
  [tokens.landing.see_documentation]: 'Ver a documentação',
  [tokens.files.integration.status.disconnected]: 'Não conectado',
  [tokens.files.integration.status.connected]: 'Conectado',
  [tokens.files.integration.action.disconnected]: 'Configurar integração',
  [tokens.files.integration.action.connected]: 'Selecionar pastas',
  [tokens.files.integration.action.syncFolders]: 'Pastas sincronizadas com sucesso',
  [tokens.files.integration.selectFolders.header]: 'Selecione as pastas para sincronizar',
  [tokens.files.integration.selectFolders.selectAllFolders]: 'Selecionar todas as pastas',
  [tokens.files.integration.selectFolders.noFolders.googledrive]: 'Nenhuma pasta encontrada no seu Google Drive',
  [tokens.files.integration.selectFolders.noFolders.onedrive]: 'Nenhuma pasta encontrada no seu OneDrive',
  [tokens.files.integration.selectFolders.noFolders.sharepoint]: 'Nenhuma pasta encontrada no seu site do SharePoint',
  [tokens.files.integration.selectFolders.noFolders.sharepointSites]: 'Nenhum site encontrado no seu SharePoint',
  [tokens.ui.common.action.connect]: 'Conectar',
  [tokens.ui.common.action.disconnect]: 'Desconectar',
  [tokens.ui.common.action.improve]: 'Melhorar',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.all]: 'Todos feedbacks',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.positive]: 'Positivos',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.negative]: 'Negativos',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.none]: 'Sem feedback',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.label]: 'Filtrar feedback por tipo',
  [tokens.dashboard.chatHistoryTable.feedback.positive.label]: 'Feedback positivo',
  [tokens.dashboard.chatHistoryTable.feedback.negative.label]: 'Feedback negativo',
  [tokens.dashboard.chatHistoryTable.metadataFilter.title]: 'Metadados',
  [tokens.dashboard.chatHistoryTable.metadataFilter.subtitle]: 'Filtros de Metadados',
  [tokens.dashboard.chatHistoryTable.metadataFilter.addFilter]: 'Adicionar filtro',
  [tokens.dashboard.chatHistoryTable.metadataFilter.supportedTypes]: 'Tipos suportados',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeText]: 'Texto: qualquer string',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeNumber]: 'Número: 123, 45.67',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeBoolean]: 'Booleano: true, false',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeNull]: 'Null: null',
  [tokens.dashboard.chatHistoryTable.metadataFilter.key]: 'Chave',
  [tokens.dashboard.chatHistoryTable.metadataFilter.value]: 'Valor',
  [tokens.workstation.feedbackModal.suggestedReasons.incorrect]: 'Está errada',
  [tokens.workstation.feedbackModal.suggestedReasons.outdated]: 'Contém informações desatualizadas',
  [tokens.workstation.feedbackModal.suggestedReasons.invented]: 'Inventou informações',
  [tokens.workstation.feedbackModal.suggestedReasons.irrelevant]: 'É irrelevante',
  [tokens.workstation.feedbackModal.suggestedReasons.ignored]: 'Ignorou parte importante da pergunta',
  [tokens.workstation.feedbackModal.suggestedReasons.generic]: 'É muito genérica',
  [tokens.workstation.feedbackModal.suggestedReasons.shallow]: 'É superficial / falta profundidade',
  [tokens.workstation.feedbackModal.suggestedReasons.confusing]: 'É confusa ou difícil de entender',
  [tokens.workstation.feedbackModal.suggestedReasons.tooTechnical]: 'É muito técnica',
  [tokens.workstation.feedbackModal.suggestedReasons.redundant]: 'É redundante',
  [tokens.workstation.feedbackModal.suggestedReasons.biased]: 'Parece enviesada',
  [tokens.workstation.feedbackModal.suggestedReasons.title]: 'Por que não foi útil?',
  [tokens.workstation.feedbackModal.input.placeholder]: 'Descreva o que não foi útil ou o que poderia melhorar (opcional)',
  [tokens.workstation.feedbackModal.cancel]: 'Cancelar',
  [tokens.workstation.feedbackModal.sendFeedback]: 'Enviar feedback',
  [tokens.workstation.feedbackModal.thankYouFeedback]: 'Obrigado pelo feedback!',
  [tokens.fileSearch.graph.noResults]: 'Nenhum resultado encontrado',
  [tokens.fileSearch.nodeMenu.basicInfo]: 'Informações Básicas',
  [tokens.fileSearch.nodeMenu.totalFiles]: 'Total de Arquivos',
  [tokens.fileSearch.nodeMenu.totalSize]: 'Tamanho Total',
  [tokens.fileSearch.nodeMenu.category]: 'Categoria',
  [tokens.fileSearch.nodeMenu.creationDate]: 'Data de Criação',
  [tokens.fileSearch.nodeMenu.visibility]: 'Visibilidade',
  [tokens.fileSearch.nodeMenu.public]: 'Público',
  [tokens.fileSearch.nodeMenu.private]: 'Privado',
  [tokens.fileSearch.nodeMenu.accessPermissions]: 'Permissões de Acesso',
  [tokens.fileSearch.nodeMenu.extension]: 'Extensão',
  [tokens.fileSearch.nodeMenu.size]: 'Tamanho',
  [tokens.fileSearch.loading.message]: 'Construindo grafo neural...',
  [tokens.fileSearch.sidebar.fileSearch]: 'Buscar arquivos',
  [tokens.fileSearch.nodeMenu.processingStatus]: 'Status de Processamento',
  [tokens.fileSearch.graph.searchTextLoadScreen]: 'Estou processando os dados, isso pode levar alguns segundos...',
  [tokens.blog.title.whatsNew]: 'O que há de novo?',
  [tokens.blog.section.moreContent]: 'Mais conteúdo',
  [tokens.blog.navigation.back]: 'Voltar',
  [tokens.blog.navigation.viewAllPosts]: 'Ver todos os posts',
  [tokens.blog.navigation.backToBlog]: 'Voltar ao Blog',
  [tokens.blog.search.placeholder]: 'Digite para pesquisar...',
  [tokens.blog.search.resultsFor]: 'Resultados para',
  [tokens.blog.search.resultCount.singular]: 'post encontrado',
  [tokens.blog.search.resultCount.plural]: 'posts encontrados',
  [tokens.blog.loading.posts]: 'Carregando posts...',
  [tokens.blog.loading.singlePost]: 'Carregando post...',
  [tokens.blog.error.loadPosts.title]: 'Erro ao carregar posts',
  [tokens.blog.error.loadPosts.description]: 'Ocorreu um erro ao carregar os posts do blog. Tente novamente mais tarde.',
  [tokens.blog.empty.noPosts.title]: 'Nenhum post encontrado',
  [tokens.blog.empty.noPosts.searchDescription]: 'Tente ajustar os termos de busca para encontrar posts.',
  [tokens.blog.empty.noPosts.generalDescription]: 'Ainda não há posts publicados no blog.',
  [tokens.blog.notFound.title]: 'Post não encontrado',
  [tokens.blog.notFound.noSlug]: 'Slug do post não foi fornecida na URL.',
  [tokens.blog.notFound.description]: 'O post que você está procurando não existe ou foi removido.',
  [tokens.blog.post.readingTime.unit]: 'min',
  [tokens.blog.post.readingTime.full]: 'min de leitura',
  [tokens.blog.post.author.by]: 'Por',
  [tokens.blog.post.author.unknown]: 'Autor desconhecido',
  [tokens.blog.pagination.previous]: 'Anterior',
  [tokens.blog.pagination.next]: 'Próxima',
  [tokens.blog.date.notAvailable]: 'Data não disponível',
  [tokens.blog.date.invalid]: 'Data inválida',
  [tokens.blog.content.titleNotAvailable]: 'Título não disponível',
  [tokens.blog.content.contentNotAvailable]: 'Conteúdo não disponível',
  [tokens.blog.content.defaultImageAlt]: 'Post do blog',
  [tokens.blog.external.documentation]: 'Documentação',
  [tokens.blog.external.apiStatus]: 'Status da API',
  [tokens.blog.accessibility.backToBlog]: 'Voltar ao Blog',
  [tokens.notifications.platform.title]: 'Notificações',
  [tokens.notifications.platform.empty.title]: 'Nenhuma notificação',
  [tokens.notifications.platform.empty.description]: 'Você não tem notificações no momento. Quando houver atualizações importantes elas aparecerão aqui.',
  [tokens.notifications.releaseNotes.title]: 'Release Notes',
  [tokens.notifications.releaseNotes.tooltip]: 'Release Notes',
  [tokens.notifications.releaseNotes.empty.title]: 'Nenhuma atualização disponível',
  [tokens.notifications.releaseNotes.empty.description]: 'Não há novas atualizações ou notas de versão para exibir no momento. Volte mais tarde para ver as últimas novidades!',
  [tokens.notifications.common.markAsRead]: 'Marcar como lida',
  [tokens.notifications.common.loading]: 'Carregando...',
  [tokens.notifications.common.error.fetch]: 'Falha ao buscar notificações',
  [tokens.notifications.common.error.markAsRead]: 'Falha ao marcar notificação como lida',
  [tokens.notifications.common.markAllAsRead]: 'Marcar todas como lida',
  [tokens.aihub.gatewayTitle]: 'Hub de IA',
  [tokens.aihub.gatewaySubtitle]: 'Gerencie seus agents e assistants',
  [tokens.aihub.gatewayNewFlow]: 'Novo fluxo',
  [tokens.aihub.gatewaySearchPlaceholder]: 'Buscar no hub de IA...',
  [tokens.aihub.gatewayItemsShowing]: 'Mostrando {{count}} de {{total}} itens',
  [tokens.aihub.gatewayNoResultsSearch]: 'Nenhum resultado encontrado',
  [tokens.aihub.gatewayNoResultsAgents]: 'Nenhum agente encontrado',
  [tokens.aihub.gatewayNoResultsAssistants]: 'Nenhum assistente encontrado',
  [tokens.aihub.gatewayNoResultsGeneral]: 'Nenhuma solução de IA encontrada',
  [tokens.aihub.gatewayLoadMore]: 'Mostrar mais',
  [tokens.aihub.gatewayLoading]: 'Carregando...',
  [tokens.aihub.gatewayDeleteConfirm]: 'Tem certeza que deseja deletar este {{type}}? Esta ação não pode ser desfeita.',
  [tokens.aihub.gatewayDeleteAgent]: 'agente',
  [tokens.aihub.gatewayDeleteAssistant]: 'assistente',
  [tokens.aihub.gatewayDeleteAction]: 'Deletar',
  [tokens.aihub.gatewayCreateTitle]: 'Como deseja prosseguir?',
  [tokens.aihub.gatewayCreateProcessFlow]: 'Fluxo de processos',
  [tokens.aihub.gatewayCreateProcessFlowDesc]: 'Construa um agente inteligente capaz de executar e agendar fluxos de trabalho automatizados com ou sem intervenção humana. Ideal para processamento de documentos análise de dados e automação de processos complexos.',
  [tokens.aihub.gatewayCreateConversationalFlow]: 'Fluxo conversacional',
  [tokens.aihub.gatewayCreateConversationalFlowDesc]: 'Crie um assistente conversacional inteligente que oferece interações personalizadas e precisas com base nas suas fontes de conhecimento. Perfeito para suporte ao cliente consultoria especializada e assistência contextual.',
  [tokens.aihub.gatewayFilterTitle]: 'Filtro',
  [tokens.aihub.gatewayFilterReset]: 'Redefinir',
  [tokens.aihub.gatewayFilterFlowType]: 'Tipo de fluxo',
  [tokens.aihub.gatewayFilterAll]: 'Todos',
  [tokens.aihub.gatewayFilterProcess]: 'Processo (Agente)',
  [tokens.aihub.gatewayFilterConversational]: 'Conversacional (Assistente)',
  [tokens.aihub.gatewayFilterStatus]: 'Status',
  [tokens.aihub.gatewayFilterActive]: 'Ativo',
  [tokens.aihub.gatewayFilterInactive]: 'Inativo',
  [tokens.aihub.gatewayFilterApply]: 'Aplicar',
  [tokens.aihub.gatewayFilterClear]: 'Limpar',
  [tokens.aihub.gatewayFilterSoon]: 'Em breve',
  [tokens.aihub.assistantNotFound]: 'Assistente não encontrado',
  [tokens.aihub.assistantNotFoundDesc]: 'O assistente solicitado não foi encontrado ou não existe.',
  [tokens.aihub.assistantTabsConfigure]: 'Configurar',
  [tokens.aihub.assistantTabsPersonalize]: 'Personalizar',
  [tokens.aihub.assistantTabsVersions]: 'Gerenciar Versões',
  [tokens.aihub.assistantTabsIntegrate]: 'Integrar',
  [tokens.aihub.assistantTabsPreview]: 'Prévia',
  [tokens.aihub.assistantPreviewVersion]: 'Prévia da versão:',
  [tokens.aihub.assistantConfigTitle]: 'Nome do Assistente *',
  [tokens.aihub.assistantConfigNamePlaceholder]: 'Digite o nome do assistente',
  [tokens.aihub.assistantConfigDescription]: 'Descrição',
  [tokens.aihub.assistantConfigDescriptionPlaceholder]: 'Descreva o propósito e funcionalidades do assistente',
  [tokens.aihub.assistantConfigKnowledgeTitle]: 'Vincular Base de Conhecimento',
  [tokens.aihub.assistantConfigKnowledgeEmpty]: 'Até o momento nenhuma base de conhecimento foi vinculada ao assistente.',
  [tokens.aihub.assistantConfigKnowledgeAdd]: 'Adicionar',
  [tokens.aihub.assistantConfigKnowledgeInclude]: 'Incluir base de conhecimento',
  [tokens.aihub.assistantConfigKnowledgeSelectPlaceholder]: 'Selecione uma pasta',
  [tokens.aihub.assistantConfigKnowledgeLoading]: 'Carregando...',
  [tokens.aihub.assistantConfigKnowledgeInstructionsPlaceholder]: 'Forneça orientações sobre como o assistente deve usar esta base de conhecimento',
  [tokens.aihub.assistantConfigKnowledgeRemove]: 'Remover base de conhecimento',
  [tokens.aihub.assistantPersonalizeTitle]: 'Personalização',
  [tokens.aihub.assistantPersonalizeSubtitle]: 'Personalize a aparência e comportamento do seu assistente.',
  [tokens.aihub.assistantPersonalizeAvatar]: 'Avatar',
  [tokens.aihub.assistantPersonalizeUpload]: 'Upload',
  [tokens.aihub.assistantPersonalizeLogoMaxSize]: 'Proporção 1:1 max. 5MB',
  [tokens.aihub.assistantInterfaceTitle]: 'Cores da interface',
  [tokens.aihub.assistantInterfaceHeaderBackground]: 'Fundo do cabeçalho',
  [tokens.aihub.assistantInterfaceHeaderText]: 'Texto do cabeçalho',
  [tokens.aihub.assistantInterfaceChatBackground]: 'Fundo do chat',
  [tokens.aihub.assistantInterfaceChatBorder]: 'Bordas do chat',
  [tokens.aihub.assistantInterfaceUserBalloonBackground]: 'Fundo do balão do usuário',
  [tokens.aihub.assistantInterfaceUserBalloonText]: 'Texto do balão do usuário',
  [tokens.aihub.assistantInterfaceAgentBalloonBackground]: 'Fundo do balão do assistente',
  [tokens.aihub.assistantInterfaceAgentBalloonText]: 'Texto do balão do assistente',
  [tokens.aihub.assistantInterfaceInputTextColor]: 'Cor do texto da mensagem',
  [tokens.aihub.assistantTypographyTitle]: 'Tipografia',
  [tokens.aihub.assistantTypographyGreetingMessage]: 'Mensagem de boas-vindas',
  [tokens.aihub.assistantTypographyGreetingMessagePlaceholder]: 'Olá! Sou seu assistente virtual.',
  [tokens.aihub.assistantTypographySubtitleMessage]: 'Mensagem do subtítulo',
  [tokens.aihub.assistantTypographySubtitleMessagePlaceholder]: 'Como posso ajudá-lo hoje?',
  [tokens.aihub.assistantTypographyPlaceholderMessage]: 'Placeholder do input',
  [tokens.aihub.assistantTypographyPlaceholderMessagePlaceholder]: 'Digite sua mensagem...',
  [tokens.aihub.assistantVersionsTitle]: 'Versões do Assistente',
  [tokens.aihub.assistantVersionsSubtitle]: 'Gerencie as versões do seu assistente e implante a versão desejada.',
  [tokens.aihub.assistantVersionsLoading]: 'Carregando versões...',
  [tokens.aihub.assistantVersionsEmpty]: 'Nenhuma versão encontrada para este assistente.',
  [tokens.aihub.assistantVersionsEmptyDescription]: 'Crie uma versão na aba de configurações para começar.',
  [tokens.aihub.assistantVersionsTableVersionName]: 'Nome da Versão',
  [tokens.aihub.assistantVersionsTableStatus]: 'Status',
  [tokens.aihub.assistantVersionsTableCreatedAt]: 'Criada em',
  [tokens.aihub.assistantVersionsTableDeployedAt]: 'Implantada em',
  [tokens.aihub.assistantVersionsTableDeployed]: 'Deployed',
  [tokens.aihub.assistantVersionsTableSaved]: 'Saved',
  [tokens.aihub.assistantVersionsActionsEdit]: 'Editar',
  [tokens.aihub.assistantVersionsActionsDeploy]: 'Implantar',
  [tokens.aihub.assistantVersionsActionsDeploying]: 'Implantando...',
  [tokens.aihub.assistantVersionsActionsDelete]: 'Deletar',
  [tokens.aihub.assistantVersionsActionsOpenMenu]: 'Abrir menu',
  [tokens.aihub.assistantVersionsDialogDeployTitle]: 'Confirmar Implantação',
  [tokens.aihub.assistantVersionsDialogDeployDescription]: 'Tem certeza que deseja implantar a versão {{versionName}}? Esta ação irá substituir a versão atualmente implantada.',
  [tokens.aihub.assistantVersionsDialogDeployConfirm]: 'Implantar',
  [tokens.aihub.assistantVersionsDialogDeleteTitle]: 'Confirmar Exclusão',
  [tokens.aihub.assistantVersionsDialogDeleteDescription]: 'Tem certeza que deseja deletar a versão {{versionName}}? Esta ação não pode ser desfeita.',
  [tokens.aihub.confirmationCannotBeUndone]: 'Ao alternar para a edição de outra versão, quaisquer alterações não salvas na versão atual serão perdidas.',
  [tokens.aihub.assistantVersionsDialogDeleteConfirm]: 'Deletar',
  [tokens.aihub.assistantIntegrateTitle]: 'Integração',
  [tokens.aihub.assistantIntegrateSubtitle]: 'Configure integrações com outras plataformas e serviços.',
  [tokens.aihub.assistantIntegrateWhatsappTitle]: 'WhatsApp',
  [tokens.aihub.assistantIntegrateWhatsappDescription]: 'Adicione números de WhatsApp para integrar com seu assistente.',
  [tokens.aihub.assistantIntegrateWhatsappPhoneNumber]: 'Número de telefone',
  [tokens.aihub.assistantIntegrateWhatsappPhoneNumberPlaceholder]: 'Digite o número de telefone',
  [tokens.aihub.assistantIntegrateWhatsappSearchCountry]: 'Buscar país...',
  [tokens.aihub.assistantIntegrateWhatsappCountryNotFound]: 'País não encontrado',
  [tokens.aihub.assistantIntegrateWhatsappAdd]: 'Adicionar',
  [tokens.aihub.assistantIntegrateWhatsappRegisteredNumbers]: 'Números cadastrados',
  [tokens.aihub.assistantIntegrateWhatsappEmpty]: 'Nenhum número de WhatsApp cadastrado',
  [tokens.aihub.assistantIntegrateWhatsappEmptyDescription]: 'Adicione um número para começar a integrar',
  [tokens.aihub.assistantIntegrateWhatsappStatusValidated]: 'Validado',
  [tokens.aihub.assistantIntegrateWhatsappStatusPending]: 'Aguardando validação',
  [tokens.aihub.assistantIntegrateWhatsappStatusUnknown]: 'Desconhecido',
  [tokens.aihub.assistantIntegrateIframeTitle]: 'Iframe',
  [tokens.aihub.assistantIntegrateIframeDescription]: 'Integre o assistente em sua aplicação usando iframe. Siga os passos abaixo:',
  [tokens.aihub.assistantIntegrateIframeStep1]: 'Passo 1: Insira o código de chamada de estilos e scripts na seção head/head do arquivo index.html da sua aplicação.',
  [tokens.aihub.assistantIntegrateIframeStep2]: 'Passo 2: Neste mesmo arquivo dentro da seção body/body insira o código de incorporação do assistente.',
  [tokens.aihub.assistantIntegrateIframeCopyError]: 'Erro ao copiar texto',
  [tokens.aihub.assistantSaveVersionTitle]: 'Salvar Versão',
  [tokens.aihub.assistantSaveVersionVersionName]: 'Nome da Versão',
  [tokens.aihub.assistantSaveVersionVersionNamePlaceholder]: 'Digite o nome da versão',
  [tokens.aihub.assistantSaveVersionAutoDeploy]: 'Implantar versão automaticamente',
  [tokens.aihub.assistantSaveVersionAutoDeployDescription]: 'Quando você implanta uma versão, ela é aplicada instantaneamente aos seus assistentes integrados.',
  [tokens.aihub.assistantSaveVersionCancel]: 'Cancelar',
  [tokens.aihub.assistantSaveVersionSave]: 'Salvar Versão',
  [tokens.aihub.assistantSaveVersionSaving]: 'Salvando...',
  [tokens.aihub.assistantPreviewUnsavedChanges]: 'Alterações não salvas',
  [tokens.aihub.assistantPreviewDiscardChanges]: 'Descartar alterações',
  [tokens.aihub.assistantPreviewSaveVersion]: 'Salvar versão',
  [tokens.aihub.assistantPreviewNewConversation]: 'Novo chat',
  [tokens.aihub.assistantPreviewLoading]: 'Carregando...',
  [tokens.aihub.assistantErrorCreateAgent]: 'Erro ao criar agente',
  [tokens.aihub.assistantErrorCreateAgentDescription]: 'Não foi possível criar o agente',
  [tokens.aihub.assistantErrorCreateAssistant]: 'Erro ao criar assistente',
  [tokens.aihub.assistantErrorCreateAssistantDescription]: 'Não foi possível criar o assistente',
  [tokens.aihub.validate]: 'Validate',
  [tokens.aihub.whatsappPhoneAlreadyExists]: 'This phone number has already been added',
  [tokens.aihub.whatsappValidationError]: 'Error validating WhatsApp number',
  [tokens.aihub.whatsappValidationSuccess]: 'WhatsApp validated successfully',
  [tokens.aihub.whatsappValidationTitle]: 'WhatsApp Validation',
  [tokens.aihub.whatsappValidationDescription]: 'Validating number {phone}',
  [tokens.aihub.whatsappValidatingPhone]: 'Validating phone number...',
  [tokens.aihub.whatsappGeneratingQRCode]: 'Generating QR Code...',
  [tokens.aihub.whatsappScanQRCode]: 'Scan the QR code with WhatsApp',
  [tokens.aihub.whatsappWaitingForScan]: 'Waiting for QR code scan...',
  [tokens.aihub.whatsappConnecting]: 'Connecting to WhatsApp...',
  [tokens.aihub.whatsappAuthenticated]: 'WhatsApp Authenticated',
  [tokens.aihub.whatsappAuthenticatedDescription]: 'Your WhatsApp has been successfully connected',
  [tokens.aihub.whatsappAuthenticationFailed]: 'WhatsApp authentication failed',
  [tokens.aihub.whatsappValidationFailed]: 'Validation Failed',
  [tokens.aihub.whatsappVersionDeployed]: 'New version created and deployed with WhatsApp',
  [tokens.aihub.whatsappVersionDeployError]: 'Error creating version with WhatsApp',
  [tokens.aihub.tryAgain]: 'Try Again',
  [tokens.aihub.error]: 'Error',
  [tokens.aihub.success]: 'Success',
  [tokens.aihub.whatsappRemovedSuccessfully]: 'WhatsApp removed successfully',
  [tokens.aihub.whatsappRemovalError]: 'Failed to remove WhatsApp',
  [tokens.aihub.whatsappPhoneAlreadyExists]: 'This phone number is already added',
  [tokens.aihub.whatsappPhoneAlreadyUsed]: 'This WhatsApp number is already connected to another assistant',
  [tokens.aihub.whatsappRevalidationRequired]: 'WhatsApp validation required for this version',
  [tokens.aihub.gatewayFilterSelectAuthors]: 'Autores',
  [tokens.aihub.gatewayFilterAuthorsPlaceholder]: 'Selecione autores para filtrar...',
  [tokens.aihub.gatewayFilterClearAuthors]: 'Limpar autores',
  [tokens.aihub.gatewayFilterMy]: 'Meus',
  [tokens.aihub.gatewayFilterShared]: 'Compartilhados',
  [tokens.tickets.page.title]: 'Suporte',
  [tokens.tickets.page.subtitle]: 'Gerencie seus tickets de suporte',
  [tokens.tickets.create.button]: 'Criar Ticket',
  [tokens.tickets.search.placeholder]: 'Buscar tickets...',
  [tokens.tickets.filter.status.placeholder]: 'Filtrar por status',
  [tokens.tickets.filter.status.all]: 'Todos os status',
  [tokens.tickets.filter.status.open]: 'Aberto',
  [tokens.tickets.filter.status.in_progress]: 'Em Progresso',
  [tokens.tickets.filter.status.blocked]: 'Bloqueado',
  [tokens.tickets.filter.status.resolved]: 'Resolvido',
  [tokens.tickets.filter.type.placeholder]: 'Filtrar por tipo',
  [tokens.tickets.filter.type.all]: 'Todos os tipos',
  [tokens.tickets.filter.type.technical_problems]: 'Problemas Técnicos',
  [tokens.tickets.filter.type.integration_problems]: 'Problemas de Integração',
  [tokens.tickets.filter.type.security_issues]: 'Problemas de Segurança',
  [tokens.tickets.filter.type.suggestions]: 'Sugestões',
  [tokens.tickets.filter.type.others]: 'Outros',
  [tokens.tickets.error.load_title]: 'Erro ao carregar tickets',
  [tokens.tickets.error.load_description]: 'Ocorreu um erro ao carregar os tickets. Tente novamente mais tarde.',
  [tokens.tickets.empty.title]: 'Nenhum ticket encontrado',
  [tokens.tickets.empty.description]: 'Não há tickets para exibir. Crie um novo ticket para começar.',
  [tokens.tickets.table.title_column]: 'Título do ticket',
  [tokens.tickets.table.type_column]: 'Tipo',
  [tokens.tickets.table.created_date_column]: 'Data de abertura',
  [tokens.tickets.table.deadline_column]: 'Prazo',
  [tokens.tickets.table.status_column]: 'Estado',
  [tokens.tickets.table.actions_column]: 'Ações',
  [tokens.tickets.table.deadline_undefined]: 'Não definido',
  [tokens.tickets.table.deadline_not_estimated]: 'Ainda não estimado - aguarde seu atendimento',
  [tokens.tickets.table.no_results]: 'Nenhum resultado encontrado.',
  [tokens.tickets.table.chat_resolved_tooltip]: 'Ticket resolvido - conversa não disponível',
  [tokens.tickets.table.chat_available_tooltip]: 'Chat with support',
  [tokens.tickets.table.evidence_resolved_tooltip]: 'Ticket resolvido - não é possível enviar evidências',
  [tokens.tickets.table.evidence_button]: 'Enviar evidências',
  [tokens.tickets.table.close_resolved_tooltip]: 'Ticket resolvido - não é possível encerrar',
  [tokens.tickets.table.close_button]: 'Encerrar ticket',
  [tokens.tickets.detail.title_label]: 'Título',
  [tokens.tickets.detail.deadline_label]: 'Prazo',
  [tokens.tickets.detail.description_label]: 'Descrição',
  [tokens.tickets.detail.attachments_label]: 'Anexos',
  [tokens.tickets.detail.no_attachments]: 'Nenhum anexo',
  [tokens.tickets.detail.created_at]: 'Criado em',
  [tokens.tickets.detail.deadline_resolution]: 'Prazo de Resolução:',
  [tokens.tickets.detail.type_label]: 'Tipo',
  [tokens.tickets.detail.loading]: 'Carregando ticket...',
  [tokens.tickets.detail.error]: 'Erro ao carregar ticket',
  [tokens.tickets.create.modal.title]: 'Criar Novo Ticket',
  [tokens.tickets.create.title_label]: 'Título *',
  [tokens.tickets.create.title_placeholder]: 'Digite o título do ticket',
  [tokens.tickets.create.type_label]: 'Tipo *',
  [tokens.tickets.create.type_placeholder]: 'Selecione o tipo',
  [tokens.tickets.create.description_label]: 'Descrição *',
  [tokens.tickets.create.description_placeholder]: 'Descreva detalhadamente o problema ou solicitação',
  [tokens.tickets.create.attachments_label]: 'Anexos',
  [tokens.tickets.create.attachments_drag_text]: 'Arraste arquivos aqui ou clique para selecionar',
  [tokens.tickets.create.attachments_button]: 'Selecionar Arquivos',
  [tokens.tickets.create.selected_files_label]: 'Arquivos selecionados:',
  [tokens.tickets.create.cancel_button]: 'Cancelar',
  [tokens.tickets.create.submit_button]: 'Criar Ticket',
  [tokens.tickets.create.submitting_button]: 'Criando...',
  [tokens.tickets.create.success_title]: 'Ticket criado',
  [tokens.tickets.create.success_description]: 'O ticket foi criado com sucesso.',
  [tokens.tickets.create.error_title]: 'Erro ao criar ticket',
  [tokens.tickets.create.error_description]: 'Não foi possível criar o ticket',
  [tokens.tickets.chat.title]: 'Chat with support',
  [tokens.tickets.chat.reference]: 'Referência:',
  [tokens.tickets.chat.empty_title]: 'Nenhuma mensagem ainda',
  [tokens.tickets.chat.empty_subtitle]: 'Seja o primeiro a iniciar a conversa!',
  [tokens.tickets.chat.input_placeholder]: 'Digite sua mensagem',
  [tokens.tickets.chat.user_label]: 'Eu',
  [tokens.tickets.chat.support_label]: 'Suporte',
  [tokens.tickets.chat.conversation_title]: 'Conversar com o suporte',
  [tokens.tickets.chat.conversation_subtitle]: 'Nossa equipe de especialistas tratará o seu caso e forncerá uma solução assim que possível.',
  [tokens.tickets.chat.no_messages_title]: 'Nenhuma mensagem ainda',
  [tokens.tickets.chat.no_messages_subtitle]: 'Inicie a conversa enviando uma mensagem',
  [tokens.tickets.chat.input_placeholder_detail]: 'Digite sua mensagem...',
  [tokens.tickets.close.dialog_title]: 'Encerrar Ticket',
  [tokens.tickets.close.dialog_description]: 'Tem certeza que deseja encerrar este ticket? Esta ação não pode ser desfeita.',
  [tokens.tickets.close.dialog_confirm]: 'Encerrar',
  [tokens.tickets.status.open]: 'Aberto',
  [tokens.tickets.status.in_progress]: 'Em Progresso',
  [tokens.tickets.status.blocked]: 'Bloqueado',
  [tokens.tickets.status.resolved]: 'Finalizado',
  [tokens.tickets.type.technical_problems]: 'Técnico',
  [tokens.tickets.type.integration_problems]: 'Integração',
  [tokens.tickets.type.security_issues]: 'Segurança',
  [tokens.tickets.type.suggestions]: 'Sugestões',
  [tokens.tickets.type.others]: 'Outros',
  [tokens.assistant.tools.title]: 'Ferramentas',
  [tokens.assistant.tools.extractions.title]: 'Extrações',
  [tokens.assistant.tools.extractions.description.message]: 'Configure campos para coletar informações durante conversas',
  [tokens.assistant.tools.extractions.empty.message]: 'Nenhuma extração configurada',
  [tokens.assistant.tools.extractions.empty.description]: 'Crie uma nova extração para começar a coletar informações dos usuários',
  [tokens.assistant.tools.extractions.add]: 'Adicionar Extração',
  [tokens.assistant.tools.extractions.create]: 'Criar Extração',
  [tokens.assistant.tools.extractions.edit]: 'Editar Extração',
  [tokens.assistant.tools.extractions.delete.message]: 'Deletar Extração',
  [tokens.assistant.tools.extractions.delete.confirm]: 'Tem certeza que deseja deletar esta extração?',
  [tokens.assistant.tools.extractions.delete.description]: 'Esta ação não pode ser desfeita. Os dados já coletados serão mantidos.',
  [tokens.assistant.tools.extractions.name.message]: 'Nome da Extração',
  [tokens.assistant.tools.extractions.name.placeholder]: 'Ex: Dados do Cliente',
  [tokens.assistant.tools.extractions.description.label]: 'Descrição',
  [tokens.assistant.tools.extractions.description.placeholder]: 'Descreva o que esta extração coleta',
  [tokens.assistant.tools.extractions.fields]: 'Campos',
  [tokens.assistant.tools.extractions.field.name.message]: 'Nome do Campo',
  [tokens.assistant.tools.extractions.field.name.placeholder]: 'Ex: nome_completo',
  [tokens.assistant.tools.extractions.field.description.message]: 'Descrição do Campo',
  [tokens.assistant.tools.extractions.field.description.placeholder]: 'Ex: Nome completo do usuário',
  [tokens.assistant.tools.extractions.field.examples.message]: 'Exemplos',
  [tokens.assistant.tools.extractions.field.examples.placeholder]: 'Adicione exemplos de valores esperados',
  [tokens.assistant.tools.extractions.field.required]: 'Campo Obrigatório',
  [tokens.assistant.tools.extractions.field.add]: 'Adicionar Campo',
  [tokens.assistant.tools.extractions.field.remove]: 'Remover Campo',
  [tokens.assistant.tools.extractions.save]: 'Salvar Extração',
  [tokens.assistant.tools.extractions.cancel]: 'Cancelar',
  [tokens.assistant.tools.extractions.success.created]: 'Extração criada com sucesso',
  [tokens.assistant.tools.extractions.success.updated]: 'Extração atualizada com sucesso',
  [tokens.assistant.tools.extractions.success.deleted]: 'Extração deletada com sucesso',
  [tokens.assistant.tools.extractions.error.create]: 'Erro ao criar extração',
  [tokens.assistant.tools.extractions.error.update]: 'Erro ao atualizar extração',
  [tokens.assistant.tools.extractions.error.delete]: 'Erro ao deletar extração',
  [tokens.assistant.tools.extractions.validation.name.required]: 'Nome da extração é obrigatório',
  [tokens.assistant.tools.extractions.validation.description.required]: 'Descrição da extração é obrigatória',
  [tokens.assistant.tools.extractions.validation.fields.required]: 'Pelo menos um campo é obrigatório',
  [tokens.assistant.tools.extractions.validation.field.name.required]: 'Nome do campo é obrigatório',
  [tokens.assistant.tools.extractions.validation.field.description.required]: 'Descrição do campo é obrigatória',
  [tokens.assistant.collectedData.title]: 'Dados Coletados',
  [tokens.assistant.collectedData.empty.message]: 'Nenhum dado coletado ainda',
  [tokens.assistant.collectedData.empty.description]: 'Os dados coletados através das extrações aparecerão aqui',
  [tokens.assistant.collectedData.export]: 'Exportar para CSV',
  [tokens.assistant.collectedData.refresh]: 'Atualizar',
  [tokens.assistant.collectedData.filter.extraction]: 'Filtrar por Extração',
  [tokens.assistant.collectedData.filter.date]: 'Filtrar por Data',
  [tokens.assistant.collectedData.filter.chat]: 'Filtrar por Conversa',
  [tokens.assistant.collectedData.table.date]: 'Data/Hora',
  [tokens.assistant.collectedData.table.chat]: 'ID da Conversa',
  [tokens.assistant.collectedData.table.extraction]: 'Extração',
  [tokens.assistant.collectedData.table.field]: 'Campo',
  [tokens.assistant.collectedData.table.value]: 'Valor',
  [tokens.assistant.collectedData.loading]: 'Carregando dados...',
  [tokens.assistant.collectedData.error]: 'Erro ao carregar dados coletados',
  [tokens.assistant.collectedData.perChat]: 'Por Conversa',
  [tokens.assistant.collectedData.allData]: 'Todos os Dados',
  [tokens.assistant.version.tools.warning]: 'As ferramentas configuradas serão aplicadas apenas nesta versão',
  [tokens.assistant.version.deployed]: 'Implantada',
  [tokens.assistant.dashboard.title]: 'Visão Geral',
  [tokens.assistant.dashboard.collectedData]: 'Dados Coletados',
  [tokens.assistant.dashboard.conversations]: 'Conversas',
  [tokens.assistant.dashboard.conversationsDesc]: 'Estatísticas e métricas de conversas',
  [tokens.assistant.dashboard.versions]: 'Versões',
  [tokens.assistant.dashboard.versionsDesc]: 'Gerenciamento de versões do assistente',
  [tokens.assistant.dashboard.settings]: 'Configurações',
  [tokens.assistant.dashboard.noDeployedVersion]: 'Nenhuma versão implantada',
  [tokens.assistant.dashboard.recentVersions]: 'Versões Recentes',
  [tokens.assistant.dashboard.activeConversations]: 'conversas ativas',
  [tokens.assistant.dashboard.avgMessages]: 'Média de mensagens',
  [tokens.assistant.dashboard.satisfaction]: 'Satisfação',
  [tokens.assistant.dashboard.uniqueUsers]: 'usuários únicos',
  [tokens.assistant.mention.createExtraction]: 'Criar nova extração',
  [tokens.assistant.mention.addField]: 'Adicionar campo',
  [tokens.assistant.mention.fieldExample]: 'Exemplo do campo',
  [tokens.assistant.extraction.tooltip]: 'Tab para sair da menção • Click em menções amarelas para criar extração',
  [tokens.assistant.extraction.update_temporary]: 'Extração atualizada temporariamente',
  [tokens.assistant.extraction.update_temporary_description]: 'As alterações serão salvas ao criar uma nova versão',
  [tokens.assistant.extraction.create_temporary]: 'Extração criada temporariamente',
  [tokens.assistant.extraction.create_temporary_description]: 'Será salva permanentemente ao criar nova versão',
  [tokens.assistant.extraction.unsaved_badge]: 'Extrações não salvas',
  [tokens.assistant.extraction.inserted]: 'Extração inserida',
  [tokens.assistant.extraction.inserted_description]: '@{{mentionName}} foi inserida no texto',
  [tokens.assistant.extraction.field_placeholder]: 'nome_do_campo',
  [tokens.assistant.extraction.field_description]: 'Campo para coletar {{fieldName}}',
  [tokens.assistant.extraction.steps.name]: 'Nome',
  [tokens.assistant.extraction.steps.examples]: 'Exemplos',
  [tokens.assistant.extraction.steps.description]: 'Descrição',
  [tokens.assistant.extraction.update_button]: 'Atualizar',
  [tokens.assistant.dashboard.metrics.conversations]: 'Conversas',
  [tokens.assistant.dashboard.metrics.conversations_tooltip]: 'Total de conversas',
  [tokens.assistant.dashboard.metrics.users]: 'Usuários',
  [tokens.assistant.dashboard.metrics.users_tooltip]: 'Usuários únicos',
  [tokens.assistant.dashboard.metrics.extractions]: 'Extrações',
  [tokens.assistant.dashboard.metrics.extractions_tooltip]: 'Total de informações extraídas',
  [tokens.assistant.dashboard.metrics.satisfaction]: 'Satisfação',
  [tokens.assistant.dashboard.metrics.satisfaction_tooltip]: 'Taxa de satisfação',
  [tokens.assistant.dashboard.metrics.response_rate]: 'Taxa de Resposta',
  [tokens.assistant.dashboard.metrics.response_rate_tooltip]: 'Conversas respondidas pelo assistente',
  [tokens.assistant.dashboard.health.title]: 'Como está meu Assistant?',
  [tokens.assistant.dashboard.health.subtitle]: 'Indicadores de saúde e performance em tempo real',
  [tokens.assistant.dashboard.health.excellent]: 'Excelente',
  [tokens.assistant.dashboard.health.attention]: 'Atenção Necessária',
  [tokens.assistant.dashboard.health.action]: 'Requer Ação Imediata',
  [tokens.assistant.dashboard.health.response_rate_desc]: 'Porcentagem de consultas que receberam resposta',
  [tokens.assistant.dashboard.health.success_rate]: 'Taxa de Sucesso',
  [tokens.assistant.dashboard.health.success_rate_desc]: 'Porcentagem de respostas consideradas precisas',
  [tokens.assistant.dashboard.health.satisfaction_desc]: 'Avaliação média dos usuários sobre as respostas',
  [tokens.assistant.dashboard.health.availability]: 'Disponibilidade',
  [tokens.assistant.dashboard.health.availability_desc]: 'Tempo que o assistant esteve disponível para uso',
  [tokens.assistant.dashboard.health.status]: 'Status Geral',
  [tokens.assistant.dashboard.health.score]: 'Score de saúde',
  [tokens.assistant.dashboard.improvements.high_impact]: 'Alto Impacto',
  [tokens.assistant.dashboard.improvements.medium_impact]: 'Impacto Médio',
  [tokens.assistant.dashboard.improvements.low_impact]: 'Baixo Impacto',
  [tokens.assistant.dashboard.improvements.easy]: 'Fácil',
  [tokens.assistant.dashboard.improvements.medium]: 'Médio',
  [tokens.assistant.dashboard.improvements.hard]: 'Difícil',
  [tokens.assistant.dashboard.improvements.progress]: 'Progresso atual',
  [tokens.assistant.dashboard.improvements.difficulty]: 'Dificuldade',
  [tokens.assistant.dashboard.improvements.improve_response_rate]: 'Melhorar Taxa de Resposta',
  [tokens.assistant.dashboard.improvements.improve_response_rate_desc]: 'Otimizar o sistema para reduzir falhas e aumentar a confiabilidade das respostas.',
  [tokens.assistant.dashboard.improvements.analyze_failures]: 'Analisar Falhas',
  [tokens.assistant.dashboard.improvements.increase_accuracy]: 'Aumentar Precisão das Respostas',
  [tokens.assistant.dashboard.improvements.increase_accuracy_desc]: 'Treinar melhor o assistente com exemplos mais específicos do seu domínio.',
  [tokens.assistant.dashboard.improvements.review_training]: 'Revisar Treinamento',
  [tokens.assistant.dashboard.improvements.improve_satisfaction]: 'Melhorar Satisfação dos Usuários',
  [tokens.assistant.dashboard.improvements.improve_satisfaction_desc]: 'Coletar mais feedback e ajustar respostas baseado nas preferências dos usuários.',
  [tokens.assistant.dashboard.improvements.collect_feedback]: 'Coletar Feedback',
  [tokens.assistant.dashboard.improvements.reduce_response_time]: 'Reduzir Tempo de Resposta',
  [tokens.assistant.dashboard.improvements.reduce_response_time_desc]: 'Otimizar processamento para responder mais rapidamente às consultas dos usuários.',
  [tokens.assistant.dashboard.improvements.optimize_performance]: 'Otimizar Performance',
  [tokens.assistant.dashboard.improvements.increase_data_collection]: 'Aumentar Coleta de Dados',
  [tokens.assistant.dashboard.improvements.increase_data_collection_desc]: 'Configurar mais extrações para coletar informações valiosas dos usuários.',
  [tokens.assistant.dashboard.improvements.create_extractions]: 'Criar Extrações',
  [tokens.assistant.dashboard.improvements.increase_engagement]: 'Aumentar Engajamento',
  [tokens.assistant.dashboard.improvements.increase_engagement_desc]: 'Promover mais o assistente ou melhorar a experiência inicial dos usuários.',
  [tokens.assistant.dashboard.improvements.marketing_strategies]: 'Estratégias de Marketing',
  [tokens.assistant.dashboard.collected.filtered]: 'Filtrado',
  [tokens.assistant.dashboard.collected.all]: 'Todas',
  [tokens.assistant.dashboard.collected.title]: 'Informações Coletadas',
  [tokens.assistant.dashboard.collected.subtitle]: 'Dados extraídos pelos assistentes',
  [tokens.assistant.dashboard.collected.total]: 'Total',
  [tokens.assistant.dashboard.collected.today]: 'Hoje',
  [tokens.assistant.dashboard.collected.extractions]: 'Extrações',
  [tokens.assistant.dashboard.collected.fields]: 'Campos',
  [tokens.assistant.dashboard.collected.total_collected]: 'Total coletado',
  [tokens.assistant.dashboard.collected.unique_fields]: 'Campos únicos',
  [tokens.assistant.dashboard.collected.all_extractions]: 'Todas as extrações',
  [tokens.assistant.dashboard.peak.title]: 'Horários de Pico',
  [tokens.assistant.dashboard.peak.subtitle]: 'Análise de atividade por dia e hora',
  [tokens.assistant.dashboard.peak.peak_hour]: 'Horário de Pico',
  [tokens.assistant.dashboard.peak.conversations_at_time]: '{{count}} conversas neste horário',
  [tokens.assistant.dashboard.peak.peak_time_alert]: 'Horário de pico!',
  [tokens.assistant.dashboard.peak.busiest_day]: 'Dia Mais Ativo',
  [tokens.assistant.dashboard.peak.total_analyzed]: 'Total Analisado',
  [tokens.assistant.dashboard.peak.conversations_last_days]: '{{count}} conversas nos últimos {{days}} dias',
  [tokens.assistant.dashboard.peak.heatmap_title]: 'Mapa de Calor - Atividade por Horário',
  [tokens.assistant.dashboard.peak.less]: 'Menos',
  [tokens.assistant.dashboard.peak.more]: 'Mais',
  [tokens.assistant.dashboard.peak.busiest_hours]: 'Horários Mais Movimentados',
  [tokens.assistant.dashboard.peak.conversations]: 'conversas',
  [tokens.assistant.dashboard.peak.sunday]: 'Dom',
  [tokens.assistant.dashboard.peak.monday]: 'Seg',
  [tokens.assistant.dashboard.peak.tuesday]: 'Ter',
  [tokens.assistant.dashboard.peak.wednesday]: 'Qua',
  [tokens.assistant.dashboard.peak.thursday]: 'Qui',
  [tokens.assistant.dashboard.peak.friday]: 'Sex',
  [tokens.assistant.dashboard.peak.saturday]: 'Sáb',
  [tokens.assistant.dashboard.export.conversations_report]: 'Relatório de Conversas',
  [tokens.assistant.dashboard.export.conversations_report_desc]: 'Dados completos de todas as conversas e interações',
  [tokens.assistant.dashboard.export.collected_data]: 'Dados Coletados',
  [tokens.assistant.dashboard.export.collected_data_desc]: 'Informações extraídas pelos assistentes',
  [tokens.assistant.dashboard.export.export_now]: 'Exportar Agora',
  [tokens.assistant.dashboard.export.export_data]: 'Exportar Dados',
  [tokens.assistant.dashboard.export.export_reports]: 'Exportar Relatórios',
  [tokens.assistant.dashboard.export.select_data]: 'Selecione os dados que deseja exportar',
  [tokens.assistant.dashboard.export.cancel]: 'Cancelar',
  [tokens.assistant.dashboard.export.export]: 'Exportar',
  [tokens.assistant.dashboard.export.automatic_reports]: 'Relatórios Automáticos',
  [tokens.assistant.dashboard.export.configure_automatic]: 'Configure envios automáticos por email',
  [tokens.assistant.dashboard.export.configure_schedule]: 'Configurar Agendamento',
  [tokens.assistant.dashboard.export.schedule_reports]: 'Agendar Relatórios',
  [tokens.assistant.dashboard.export.schedule_description]: 'Configure envios automáticos de relatórios por email',
  [tokens.assistant.dashboard.export.email_label]: 'Email para envio',
  [tokens.assistant.dashboard.export.email_placeholder]: 'seu@email.com',
  [tokens.assistant.dashboard.export.frequency]: 'Frequência',
  [tokens.assistant.dashboard.export.daily]: 'Diário',
  [tokens.assistant.dashboard.export.weekly]: 'Semanal',
  [tokens.assistant.dashboard.export.monthly]: 'Mensal',
  [tokens.assistant.dashboard.export.report_types]: 'Tipos de relatório',
  [tokens.assistant.dashboard.export.active_schedules]: 'Agendamentos Ativos',
  [tokens.assistant.dashboard.export.active]: 'Ativo',
  [tokens.assistant.dashboard.export.next_delivery]: 'Próximo envio:',
  [tokens.assistant.dashboard.time.minutes_suffix]: 'min',
  [tokens.assistant.extraction.press_enter_continue]: 'Pressione Enter para continuar',
  [tokens.assistant.extraction.default_field_name]: 'campo',
  [tokens.assistant.dashboard.time_filter.all_data]: 'Todos os dados',
  [tokens.assistant.dashboard.time_filter.last_hour]: 'Última hora',
  [tokens.assistant.dashboard.time_filter.last_2h]: 'Últimas 2h',
  [tokens.assistant.dashboard.time_filter.last_6h]: 'Últimas 6h',
  [tokens.assistant.dashboard.time_filter.last_12h]: 'Últimas 12h',
  [tokens.assistant.dashboard.time_filter.last_24h]: 'Últimas 24h',
  [tokens.assistant.dashboard.time_filter.today]: 'Hoje',
  [tokens.assistant.dashboard.production]: 'Produção',
  [tokens.assistant.dashboard.preview]: 'Prévia',
  [tokens.assistant.dashboard.showData]: 'Mostrar dados',
  [tokens.assistant.dashboard.hideData]: 'Ocultar dados',
  [tokens.assistant.dashboard.previewDataNotPersistent]: 'Dados de prévia não são persistentes',
  [tokens.assistant.dashboard.configure]: 'Configurar',
  [tokens.assistant.dashboard.description]: 'Acompanhe métricas e desempenho',
  [tokens.assistant.dashboard.whatsappAnalytics]: 'WhatsApp Analytics',
  [tokens.assistant.dashboard.whatsappActivityEngagement]: 'Atividade e engajamento no WhatsApp',
  [tokens.assistant.dashboard.activityLevel]: 'Nível de atividade',
  [tokens.assistant.dashboard.responseTime]: 'Tempo de resposta',
  [tokens.assistant.dashboard.totalMessages]: 'Total de mensagens',
  [tokens.assistant.dashboard.peakHours]: 'Horários de pico',
  [tokens.assistant.extraction.add_description_optional]: 'Adicionar descrição (opcional)',
  [tokens.assistant.dashboard.conversation.default_user]: 'Usuário',
  [tokens.assistant.dashboard.editAssistant]: 'Editar Assistente',
  [tokens.assistant.dashboard.improvements.title]: 'Oportunidades de Melhoria',
  [tokens.assistant.dashboard.improvements.subtitle]: 'Identifique áreas para otimizar o desempenho do seu assistente',
  [tokens.assistant.dashboard.improvements.all_perfect]: 'Tudo está perfeito!',
  [tokens.assistant.dashboard.improvements.optimal_operation]: 'Seu assistente está operando de forma ótima sem melhorias imediatas necessárias.',
  [tokens.assistant.dashboard.improvements.excellent_performance]: 'Desempenho Excelente',
  [tokens.assistant.dashboard.improvements.opportunities_identified]: '{count} oportunidades identificadas',
  [tokens.assistant.dashboard.improvements.prioritize_actions]: 'Priorize ações de alto impacto para melhores resultados',
  [tokens.assistant.dashboard.improvements.improvements]: 'melhorias',
  [tokens.assistant.dashboard.export.title]: 'Exportar e Agendar Relatórios',
  [tokens.assistant.dashboard.export.subtitle]: 'Configure exportações automáticas de dados e relatórios',
  [tokens.assistant.dashboard.export.download_reports_desc]: 'Baixe relatórios detalhados do seu assistente',
  [tokens.assistant.dashboard.export.no_schedules_yet]: 'Nenhum agendamento configurado ainda',
  [tokens.assistant.dashboard.export.paused]: 'Pausado',
  [tokens.assistant.dashboard.export.performance_metrics]: 'Métricas de Performance',
  [tokens.assistant.dashboard.export.performance_metrics_desc]: 'Análise detalhada de desempenho e eficiência',
  [tokens.assistant.dashboard.export.executive_report]: 'Relatório Executivo',
  [tokens.assistant.dashboard.export.executive_report_desc]: 'Resumo executivo com principais indicadores',
  [tokens.assistant.dashboard.export.daily_summary]: 'Resumo Diário',
  [tokens.assistant.dashboard.export.daily_summary_desc]: 'Resumo das atividades do dia',
  [tokens.assistant.dashboard.excellent]: 'Excelente',
  [tokens.assistant.dashboard.performance]: 'Desempenho',
  [tokens.assistant.dashboard.performanceMetrics]: 'Métricas de Desempenho',
  [tokens.assistant.dashboard.collected.csv_filename_prefix]: 'dados-coletados-',
  [tokens.assistant.dashboard.collected.extraction_details]: 'Detalhes da extração',
  [tokens.assistant.dashboard.collected.last_collection]: 'Última coleta',
  [tokens.assistant.dashboard.recentConversations]: 'Conversas Recentes',
  [tokens.assistant.dashboard.export.weekly_report]: 'Relatório Semanal',
  [tokens.assistant.dashboard.export.weekly_report_desc]: 'Resumo semanal com análises e tendências',
  [tokens.assistant.dashboard.export.monthly_insights]: 'Insights Mensais',
  [tokens.assistant.dashboard.export.monthly_insights_desc]: 'Análise profunda mensal com insights estratégicos',
  [tokens.assistant.dashboard.good]: 'Bom',
  [tokens.assistant.dashboard.regular]: 'Regular',
  [tokens.assistant.dashboard.activeChats]: 'Chats Ativos',
  [tokens.assistant.dashboard.uniqueUsersCount]: 'Total de Usuários Únicos',
  [tokens.assistant.dashboard.peak.insufficient_data]: 'Dados insuficientes para análise de horários',
  [tokens.assistant.createAssistantSuccess.title]: 'Assistente criado',
  [tokens.assistant.createAssistantSuccess.description]: 'O assistente foi criado com sucesso.',
  [tokens.assistant.createAssistantError.title]: 'Erro ao criar assistente',
  [tokens.assistant.createAssistantError.description]: 'Ocorreu um erro ao criar o assistente.',
  [tokens.assistant.deleteAssistantSuccess.title]: 'Assistente deletado',
  [tokens.assistant.deleteAssistantSuccess.description]: 'O assistente foi deletado com sucesso.',
  [tokens.assistant.deleteAssistantError.title]: 'Erro ao deletar assistente',
  [tokens.assistant.deleteAssistantError.description]: 'Ocorreu um erro ao deletar o assistente.',
  [tokens.assistant.createVersionSuccess.title]: 'Versão criada',
  [tokens.assistant.createVersionSuccess.description]: 'A versão foi criada com sucesso.',
  [tokens.assistant.createVersionError.title]: 'Erro ao criar versão',
  [tokens.assistant.createVersionError.description]: 'Ocorreu um erro ao criar a versão.',
  [tokens.assistant.deployVersionSuccess.title]: 'Versão implantada',
  [tokens.assistant.deployVersionSuccess.description]: 'A versão foi implantada com sucesso.',
  [tokens.assistant.deployVersionError.title]: 'Erro ao implantar versão',
  [tokens.assistant.deployVersionError.description]: 'Ocorreu um erro ao implantar a versão.',
  [tokens.assistant.deleteVersionSuccess.title]: 'Versão deletada',
  [tokens.assistant.deleteVersionSuccess.description]: 'A versão foi deletada com sucesso.',
  [tokens.assistant.deleteVersionError.title]: 'Erro ao deletar versão',
  [tokens.assistant.deleteVersionError.description]: 'Ocorreu um erro ao deletar a versão.',
  [tokens.file_table_input.dialog.title]: 'Enviar Arquivos e Links',
  [tokens.file_table_input.files.label]: 'Arquivos',
  [tokens.file_table_input.drag_drop.main_text]: 'Arraste arquivos aqui ou clique para selecionar',
  [tokens.file_table_input.drag_drop.supported_formats]: 'Suporte para PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX, MP4, MP3, WEBM',
  [tokens.file_table_input.drag_drop.max_size]: 'Tamanho máximo: 400 MB por arquivo',
  [tokens.file_table_input.selected_files.label]: 'Arquivos Selecionados',
  [tokens.file_table_input.youtube.label]: 'Links do YouTube',
  [tokens.file_table_input.youtube.warning]: 'Vídeos do YouTube podem demorar um pouco mais para aparecer após serem adicionados.',
  [tokens.file_table_input.youtube.url_placeholder]: 'Cole aqui o link do YouTube...',
  [tokens.file_table_input.youtube.name_placeholder]: 'Nome do vídeo',
  [tokens.file_table_input.youtube.add_button]: 'Adicionar Vídeo',
  [tokens.file_table_input.youtube.added_links.label]: 'Links Adicionados',
  [tokens.file_table_input.buttons.cancel]: 'Cancelar',
  [tokens.file_table_input.buttons.upload]: 'Enviar',
  [tokens.file_table_input.buttons.uploading]: 'Enviando...',
  [tokens.file_table_input.toast.cannot_upload.title]: 'Não é possível enviar arquivo',
  [tokens.file_table_input.toast.cannot_upload.description]: 'O arquivo "{fileName}" excede o limite MB da organização atual e não pôde ser carregado.',
  [tokens.file_table_input.toast.file_too_large.title]: 'Arquivo muito grande',
  [tokens.file_table_input.toast.file_too_large.description]: 'O arquivo "{fileName}" excede o limite de {limit} GB e não pôde ser carregado.',
  [tokens.file_table_input.toast.invalid_url.title]: 'URL inválida',
  [tokens.file_table_input.toast.invalid_url.description]: 'Por favor',
  [tokens.file_table_input.toast.invalid_video_id.title]: 'URL inválida',
  [tokens.file_table_input.toast.invalid_video_id.description]: 'Não foi possível extrair o ID do vídeo da URL fornecida.',
  [tokens.file_table_input.toast.duplicate_video.title]: 'Vídeo duplicado',
  [tokens.file_table_input.toast.duplicate_video.description]: 'Este vídeo já foi adicionado à lista.',
  [tokens.file_table_input.toast.no_content.title]: 'Nenhum conteúdo selecionado',
  [tokens.file_table_input.toast.no_content.description]: 'Selecione pelo menos um arquivo ou adicione um link do YouTube.',
  [tokens.file_table_input.toast.no_folder.title]: 'Pasta não selecionada',
  [tokens.file_table_input.toast.no_folder.description]: 'Selecione uma pasta antes de fazer o upload.',
  [tokens.file_table_input.toast.upload_failed.title]: 'Falha no upload',
  [tokens.file_table_input.toast.upload_failed.description]: 'Falha ao enviar "{fileName}": {error}',
  [tokens.file_table_input.toast.upload_success.title]: 'Upload realizado com sucesso',
  [tokens.file_table_input.toast.upload_success.description]: 'Arquivos e links enviados com sucesso.',
  [tokens.sidebar.translation.title]: 'Tradutor',
  [tokens.sidebar.translation.fileManage]: 'Templates',
  [tokens.sidebar.translation.glossary]: 'Glossários',
  [tokens.sidebar.translation.translation]: 'Traduções',
  [tokens.translation.fileManage.title]: 'Templates',
  [tokens.translation.fileManage.description]: 'Gerenciamento de templates de tradução',
  [tokens.translation.fileManage.searchPlaceholder]: 'Buscar templates…',
  [tokens.ui.common.openMenu]: 'Abrir menu',
  [tokens.translation.fileManage.uploadInput.sendFileForTranslation]: 'Enviar arquivo para tradução',
  [tokens.translation.fileManage.uploadInput.sendTemplate]: 'Enviar template',
  [tokens.translation.fileManage.uploadInput.templateFormattingInstructionOne]:
    'Use o marcador [/TEXTO] para indicar onde a tradução será inserida.',
  [tokens.translation.fileManage.uploadInput.templateFormattingInstructionTwo]:
    'Opcionalmente forneça formatações complementares, elas serão aplicadas apenas na tradução e não modificarão a formatação do template.',
  [tokens.translation.fileManage.uploadInput.templateFormattingExampleLabel]: 'Exemplo de marcação',
  [tokens.translation.fileManage.uploadInput.templateFormattingExampleValue]:
    '[/TEXTO, font=Arial, size=12]',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyButton]: 'Copiar',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedShort]: 'Copiado',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedTitle]: 'Exemplo copiado',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedDescription]: 'A marcação foi copiada para a área de transferência.',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyFailedTitle]: 'Falha ao copiar',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyFailedDescription]:
    'Não foi possível copiar o exemplo. Tente novamente.',
  [tokens.translation.fileManage.deleteDialog.deleteFileTitle]: 'Deletar arquivo',
  [tokens.translation.fileManage.deleteDialog.deleteFilesTitle]: 'Deletar arquivos',
  [tokens.translation.fileManage.deleteDialog.deleteFileDescription]: 'Você está prestes a deletar um arquivo. Essa ação não pode ser desfeita.',
  [tokens.translation.fileManage.deleteDialog.deleteFilesDescription]: 'Você está prestes a deletar {{count}} arquivos. Essa ação não pode ser desfeita.',
  [tokens.translation.fileManage.table.selectAllFiles]: 'Selecionar todos os arquivos',
  [tokens.translation.fileManage.table.selectRow]: 'Selecionar linha',
  [tokens.translation.fileManage.table.noFilesFound]: 'Nenhum arquivo encontrado',
  [tokens.translation.fileManage.table.loadingFiles]: 'Carregando arquivos...',
  [tokens.translation.fileManage.table.previousPage]: 'Página anterior',
  [tokens.translation.fileManage.table.nextPage]: 'Próxima página',
  [tokens.translation.fileManage.tabs.filesForTranslation]: 'Arquivos para tradução',
  [tokens.translation.fileManage.tabs.templates]: 'Templates',
  [tokens.translation.glossary.title]: 'Glossários',
  [tokens.translation.glossary.description]: 'Glossários de termos que podem ser usados durante a tradução',
  [tokens.translation.glossary.deleteDialog.deleteGlossariesTitle]: 'Deletar glossários',
  [tokens.translation.glossary.deleteDialog.deleteGlossariesDescription]: 'Você está prestes a deletar {{count}} glossários. Essa ação não pode ser desfeita.',
  [tokens.translation.glossary.table.selectAllGlossaries]: 'Selecionar todos os glossários',
  [tokens.translation.glossary.table.selectRow]: 'Selecionar linha',
  [tokens.translation.glossary.table.name]: 'Nome do Glossário',
  [tokens.translation.glossary.table.noGlossariesFound]: 'Nenhum glossário encontrado',
  [tokens.translation.glossary.table.loadingGlossaries]: 'Carregando glossários...',
  [tokens.translation.glossary.toolbar.createButton]: 'Novo glossário',
  [tokens.ui.toasts.glossary.create_success]: 'Glossário criado com sucesso.',
  [tokens.ui.toasts.glossary.update_success]: 'Glossário atualizado com sucesso.',
  [tokens.ui.toasts.glossary.delete_success]: 'Glossário deletado com sucesso.',
  [tokens.ui.toasts.glossary.duplicate_success]: 'Glossário duplicado com sucesso.',
  [tokens.ui.toasts.folder.update_success]: 'A pasta foi atualizada com sucesso',
  [tokens.ui.toasts.translation.delete_success]: 'Traduções deletadas com sucesso.',
  [tokens.file_table_input.drag_drop.max_size_translation]: 'Tamanho máximo: 50 MB por arquivo',
  [tokens.file_table_input.file_too_large_inline]: 'Arquivo excede o limite de 50MB',
  [tokens.translation.translation.title]: 'Traduções',
  [tokens.translation.translation.description]: 'Gerenciamento de traduções',
  [tokens.translation.translation.createDialog.reviewBeforeFinish]: 'Revisar antes de finalizar',
  [tokens.translation.translation.createDialog.autoSplit]: 'Divisão automática',
  [tokens.translation.translation.createDialog.autoSplitTooltip]: 'Ative esta opção para dividir automaticamente o documento de entrada em múltiplos documentos.',
  [tokens.translation.translation.createDialog.extractTables]: 'Extração de tabelas',
  [tokens.translation.translation.createDialog.start]: 'Iniciar',
  [tokens.translation.translation.pdfViewer.errorLoading]: 'Erro ao carregar PDF',
  [tokens.translation.translation.pdfViewer.zoomIn]: 'Aumentar zoom',
  [tokens.translation.translation.pdfViewer.zoomOut]: 'Diminuir zoom',
  [tokens.translation.translation.reviewDialog.couldNotLoadData]: 'Não foi possível carregar os dados da revisão.',
  [tokens.translation.translation.reviewDialog.singleEdit]: '1 edição',
  [tokens.translation.translation.reviewDialog.multipleEdits]: '{{count}} edições',
  [tokens.translation.translation.reviewDialog.title]: 'Revisão de Tradução',
  [tokens.translation.translation.reviewDialog.confirmTranslation]: 'Confirmar Tradução',
  [tokens.translation.translation.reviewDialog.sendFeedback]: 'Enviar feedback',
  [tokens.translation.translation.reviewDialog.waitApplyingChanges]: 'Aplicando as correções, elas passarão a ser utilizadas automaticamente nas próximas traduções.',
  [tokens.translation.translation.reviewDialog.preparingSingleFile]: 'Preparando seu arquivo.',
  [tokens.translation.translation.reviewDialog.preparingMultipleFiles]: 'Preparando seus arquivos.',
  [tokens.translation.translation.reviewDialog.documentOfTotal]: 'Documento {{current}} de {{total}}',
  [tokens.translation.translation.reviewDialog.reprocess]: 'Traduzir novamente',
  [tokens.translation.translation.reviewPanel.originalLabel]: 'Original ({{language}})',
  [tokens.translation.translation.reviewPanel.translatedLabel]: 'Traduzido ({{language}})',
  [tokens.translation.translation.reviewPanel.tooltipRotatePdf]: 'Rotacionar',
  [tokens.translation.translation.reviewPanel.tooltipZoomIn]: 'Aumentar Zoom',
  [tokens.translation.translation.reviewPanel.tooltipZoomOut]: 'Diminuir Zoom',
  [tokens.translation.translation.reviewPanel.tooltipZoomReset]: 'Redefinir Zoom',
  [tokens.translation.translation.feedbackDialog.title]: 'Enviar feedback',
  [tokens.translation.translation.feedbackDialog.descriptionPlaceholder]: 'Descreva o problema ou sugestão',
  [tokens.translation.translation.feedbackDialog.selectImage]: 'Selecionar imagem',
  [tokens.translation.translation.feedbackDialog.filesHint]: 'Cole ou selecione imagens ({{count}}/{{total}})',
  [tokens.translation.translation.feedbackDialog.cancel]: 'Cancelar',
  [tokens.translation.translation.feedbackDialog.submit]: 'Enviar feedback',
  [tokens.translation.translation.feedbackDialog.toast.successTitle]: 'Feedback enviado',
  [tokens.translation.translation.feedbackDialog.toast.errorTitle]: 'Falha ao enviar feedback',
  [tokens.translation.translation.feedbackDialog.toast.errorDescription]: 'Tente novamente em instantes.',
  [tokens.translation.translation.feedbackDialog.validation.descriptionMin]: 'Informe pelo menos 3 caracteres.',
  [tokens.translation.translation.feedbackDialog.validation.descriptionMax]: 'A descrição deve ter no máximo 2000 caracteres.',
  [tokens.translation.translation.feedbackDialog.validation.maxFiles]: 'Você pode anexar até {{max}} imagens por feedback.',
  [tokens.translation.translation.feedbackDialog.validation.onlyImages]: 'Apenas imagens são aceitas.',
  [tokens.translation.translation.feedbackDialog.validation.maxFileSize]: 'Apenas imagens de até 20MB são aceitas.',
  [tokens.translation.translation.selectGlossary.noGlossariesFound]: 'Nenhum glossário encontrado',
  [tokens.translation.translation.selectGlossary.placeholder]: 'Selecione o glossário',
  [tokens.translation.translation.selectGlossary.searchPlaceholder]: 'Buscar glossário',
  [tokens.translation.translation.selectTemplateFile.noFilesFound]: 'Nenhum arquivo encontrado',
  [tokens.translation.translation.selectTemplateFile.placeholder]: 'Selecione o arquivo de template',
  [tokens.translation.translation.selectTranslationFile.noFilesFound]: 'Nenhum arquivo encontrado',
  [tokens.translation.translation.selectTranslationFile.placeholder]: 'Selecione o arquivo a ser traduzido',
  [tokens.translation.translation.historyTable.status.complete]: 'Concluído',
  [tokens.translation.translation.historyTable.status.pending]: 'Pendente',
  [tokens.translation.translation.historyTable.status.running]: 'Processando',
  [tokens.translation.translation.historyTable.status.review]: 'Revisão',
  [tokens.translation.translation.historyTable.status.error]: 'Falhou',
  [tokens.translation.translation.historyTable.status.quotaExceeded]: 'Cota excedida',
  [tokens.translation.translation.historyTable.createdBy]: 'Criado por',
  [tokens.translation.translation.historyTable.openReview]: 'Revisar',
  [tokens.translation.translation.historyTable.reprocess]: 'Traduzir novamente',
  [tokens.translation.translation.reprocess.toast.startedTitle]: 'Tradução reiniciada',
  [tokens.translation.translation.reprocess.toast.startedDescription]: 'Esta tradução está sendo processada novamente.',
  [tokens.translation.translation.reprocess.toast.alreadyRunningTitle]: 'Já em execução',
  [tokens.translation.translation.reprocess.toast.alreadyRunningDescription]: 'Já existe um fluxo em andamento para esta tradução.',
  [tokens.translation.translation.reprocess.toast.errorTitle]: 'Não foi possível reprocessar',
  [tokens.translation.translation.reprocess.toast.errorDescription]: 'Algo deu errado. Tente novamente.',
  [tokens.translation.translation.historyTable.noTranslationsFound]: 'Nenhuma tradução encontrada',
  [tokens.translation.translation.historyTable.loadingTranslations]: 'Carregando traduções...',
  [tokens.translation.translation.historyToolbar.searchPlaceholder]: 'Buscar tradução',
  [tokens.translation.translation.reviewDialog.applyChanges]: 'Aplicar alterações',
  [tokens.translation.translation.reviewDialog.applyingChanges]: 'Aplicando suas alterações, aguarde um momento...',
  [tokens.translation.translation.completeDialog.title]: 'Download de Arquivos',
  [tokens.translation.translation.completeDialog.couldNotLoadData]: 'Não foi possível carregar os dados dos arquivos.',
  [tokens.translation.translation.completeDialog.originalFile]: 'Arquivo Original',
  [tokens.translation.translation.completeDialog.translatedFiles]: 'Arquivos Traduzidos',
  [tokens.translation.translation.completeDialog.translatedFile]: 'Arquivo Traduzido',
  [tokens.translation.translation.completeDialog.downloadAll]: 'Baixar Todos',
  [tokens.translation.translation.completeDialog.downloadError.title]: 'Erro ao baixar arquivos',
  [tokens.translation.translation.completeDialog.downloadError.description]: 'Não foi possível criar o arquivo ZIP. Tente novamente mais tarde.',
  [tokens.translation.translation.completeDialog.reprocess]: 'Traduzir novamente',
  [tokens.assistant.conversations.title]: 'Conversas',
  [tokens.assistant.conversations.description]: 'Visualize todas as conversas do assistant {{name}}',
  [tokens.assistant.conversations.viewAll]: 'Ver Conversas',
  [tokens.assistant.conversations.backToDashboard]: 'Voltar ao Dashboard',
  [tokens.assistant.conversations.noResults]: 'Nenhuma conversa encontrada',
  [tokens.assistant.conversations.viewDetails]: 'Ver detalhes',
  [tokens.assistant.conversations.viewConversation]: 'Visualizar conversa',
  [tokens.assistant.conversations.export]: 'Exportar CSV',
  [tokens.assistant.conversations.hiddenContent]: 'Conteúdo oculto',
  [tokens.assistant.conversations.hideSensitiveData]: 'Ocultar dados sensíveis',
  [tokens.assistant.conversations.showSensitiveData]: 'Mostrar dados sensíveis',
  [tokens.assistant.conversations.hideData]: 'Ocultar',
  [tokens.assistant.conversations.showData]: 'Mostrar',
  [tokens.assistant.conversations.columns.question]: 'Pergunta',
  [tokens.assistant.conversations.columns.response]: 'Resposta',
  [tokens.assistant.conversations.columns.user]: 'Usuário',
  [tokens.assistant.conversations.columns.email]: 'Email',
  [tokens.assistant.conversations.columns.date]: 'Data',
  [tokens.assistant.conversations.columns.extractions]: 'Extrações',
  [tokens.assistant.conversations.columns.actions]: 'Ações',
  [tokens.assistant.conversations.columns.source]: 'Versão',
  [tokens.assistant.conversations.filters.searchPlaceholder]: 'Buscar por mensagem ou email...',
  [tokens.assistant.conversations.filters.startDate]: 'Data inicial',
  [tokens.assistant.conversations.filters.endDate]: 'Data final',
  [tokens.assistant.conversations.filters.dateRange]: 'Período',
  [tokens.assistant.conversations.filters.extractionType]: 'Tipo de extração',
  [tokens.assistant.conversations.filters.allExtractions]: 'Todas as extrações',
  [tokens.assistant.conversations.filters.emailPlaceholder]: 'Filtrar por email',
  [tokens.assistant.conversations.filters.source]: 'Origem',
  [tokens.assistant.conversations.filters.allSources]: 'Todas',
  [tokens.assistant.conversations.filters.production]: 'Publicado',
  [tokens.assistant.conversations.filters.preview]: 'Preview',
  [tokens.assistant.conversations.filters.clear]: 'Limpar filtros',
  [tokens.assistant.conversations.pagination.showing]: 'Mostrando {{from}} a {{to}} de {{total}} conversas',
  [tokens.assistant.conversations.pagination.rowsPerPage]: 'Linhas por página',
  [tokens.assistant.conversations.pagination.page]: 'Página {{current}} de {{total}}',
  [tokens.assistant.conversations.pagination.firstPage]: 'Primeira página',
  [tokens.assistant.conversations.pagination.previousPage]: 'Página anterior',
  [tokens.assistant.conversations.pagination.nextPage]: 'Próxima página',
  [tokens.assistant.conversations.pagination.lastPage]: 'Última página',
  [tokens.assistant.conversations.detail.title]: 'Detalhes da Conversa',
  [tokens.assistant.conversations.detail.messagesTab]: 'Mensagens',
  [tokens.assistant.conversations.detail.extractionsTab]: 'Extrações',
  [tokens.assistant.conversations.detail.extractionsCount]: 'extrações',
  [tokens.assistant.conversations.detail.noExtractions]: 'Nenhuma extração nesta conversa',
  [tokens.assistant.conversations.detail.userLabel]: 'Usuário',
  [tokens.assistant.conversations.detail.assistantLabel]: 'Assistente',
  [tokens.assistant.conversations.detail.extractionLabel]: 'Extração',
  [tokens.assistant.conversations.detail.fieldsLabel]: 'campos',
  [tokens.assistant.conversations.detail.confidence]: 'Confiança',
  [tokens.assistant.conversations.export_csv.date]: 'Data',
  [tokens.assistant.conversations.export_csv.user]: 'Usuário',
  [tokens.assistant.conversations.export_csv.email]: 'Email',
  [tokens.assistant.conversations.export_csv.question]: 'Pergunta',
  [tokens.assistant.conversations.export_csv.response]: 'Resposta',
  [tokens.assistant.conversations.export_csv.extractions]: 'Extrações',
  [tokens.assistant.conversations.export_csv.answered]: 'Respondida',
  [tokens.assistant.conversations.export_csv.conversationId]: 'ID da Conversa',
  [tokens.ui.actions.close]: 'Fechar',
  [tokens.ui.actions.download]: 'Baixar',
};

export default translations;
